const locale = {
  BirthDate: "Tug'ilgan sanasi",
  NewPost: 'Yangi post',
  AddNews: "Yangilikni qo'shish",
  NewsText: 'Yangilikning matni',
  Publish: 'Nashr qilish',
  Cancel: 'Bekor qilish',
  DragHereOrPressToChoose: 'Fayllarni shu yerga torting yoki tanlash uchun bosing',
  ChangePassword: "Parolni o'zgartirish",
  Contact: 'Kontakt',
  PhoneAdditional: "Qo'sh. telefon raqami",
  Email: 'Email',
  Employees: 'Xodimlar',
  MoveDown: 'Pastga pasaytirish',
  OUSuccessfullyMovedDown: "Tashkiliy bo'linma muvaffaqiyatli pasaytirildi",
  Birthdays: "Tug'ilgan kunlari",
  EmailAdditional: "Qo'sh. Email",
  HigherDivision: "Yuqoridagi bo'linmasi",
  AddSubordateSubdivision: "Bo'ysunuvchi bo'linmasini qo'shish",
  EditOU: "Tashkiliy bo'linmani o'zgartirish",
  CorporatePortal: 'Korporativ portali',
  Heading: 'Sarlavha',
  OUType: "Bo'linma turi",
  EmployeeSearchWidget: 'Xodimlarni qidirish vidjeti',
  GeneralInformation: "Umumiy ma'lumotlar",
  Phone: 'Telefon',
  PostComment: 'Izohni nashr qilish',
  Today: 'Bugun',
  SearchByFIO: "F.I.O. bo'yicha qidirish",
  OrgUnitSuccessfullyChanged: "Tashkiliy bo'linmani muvaffaqiyatli o'zgartirish",
  OrgUnitSuccessfullyAdded: "Tashkiliy bo'linmani muvaffaqiyatli qo'shish",
  Description: 'Tavsif',
  ShowInOrgStructure: "Tashkiliy tuzilmasida ko'rsatish",
  Save: 'Saqlash',
  Denomination: 'Ismi',
  OUSuccessfullyDeleted: "Tashkiliy bo'linma muvaffaqiyatli o'chirish",
  MoveUp: "Tepaga ko'tarish",
  DeleteOU: "Tashkiliy bo'linmani o'chirish",
  ResourceSuccessfullyChanged: "Resurs muvaffaqiyatli o'zgartirildi",
  SecurityResponsibilities:
    "Ob'ektlar va moddiy boyliklar xavfsizligini ta'minlash, kirish/chiqishni nazorat qilish...",
  Settings: 'Sozlamalar',
  Skills: "Ko'nikmalar",
  ResourceSuccessfullyDeleted: "Resurs muvaffaqiyatli o'chirildi",
  Edit: "O'zgartirish",
  AddComment: "Izohni qo'shish",
  DeleteResource: "Resursni o'chirish",
  EventSuccessfullyAdded: 'Tadbir muvaffaqiyatli qo‘shildi',
  OldPassword: 'Eski parol',
  Login: 'Login',
  Password: 'Parol',
  ResetPassword: "Parolni qayta o'rnatish",
  HRDepartment: "HR bo'limi",
  TechSupportDepartment: "Texnik qo'llab-quvvatlash bo'limi",
  Chancellery: "Ish yuritish bo'limi",
  SubscribersDepartment: "Abonentlar bo'imi",
  ReceptionResponsibilities: 'Bosh direktorning qabul telefon raqami',
  ChancelleryResponsibilities:
    'Kirish/chiqish hujjatlari, hujjatlarning bajarilishini nazorat qilish...',
  SubscribersDepartmentResponsibilitie:
    "Mijozlarga xizmat ko'rsatish, shartnomalarni nazorat qilish ...",
  HowCanWeHelpYou: 'Sizga qanday yordam berishimiz mumkin?',
  FindInterestingDepartmentPhoneNumber:
    "Sizni qiziqtirgan bo'limning telefon raqamini quyida toping",
  ConferenceHall: 'Konferentsiya xonasi',
  Automobile: 'Avtomobil',
  ResourceSuccessfullyCreated: 'Resurs muvaffaqiyatli yaratildi',
  AreYouSureToDeleteResource: 'Siz haqiqatan ham shu resursini o‘chirmoqchimisiz?',
  ResourceEditing: "Resursni o'zgartirish",
  ResourceAdding: "Resursni qo'shish",
  Title: 'Nomi',
  ResourceType: 'Resurs turi',
  ErrorOccuredWhileAddingEvent: 'Hodisa qo‘shishda xatolik yuz berdi',
  EventSuccessfullyUpdated: 'Tadbir muvaffaqiyatli yangilandi',
  ErrorOccuredWhileUpdatingEvent: "Hodisa o'zgartirganda xatolik yuz berdi",
  Delete: "O'chirish",
  AddOU: "Tashkiliy bo'linmani qo'shish",
  ZoomAccount: 'Zoom akkaunti',
  Privacy: 'Maxfiylik',
  PubliclyAvailable: 'Ommaviy',
  AreYouSureToDeleteCalendar: 'Siz haqiqatan ham shu kalendarini o‘chirmoqchimisiz?',
  Add: "Qo'shish",
  EditingEvent: "Hodisani o'zgartirish",
  Resources: 'Resurslar',
  MyCalendar: 'Mening kalendarim',
  Modules: 'Modullar',
  HR: 'HR',
  Administrator: 'Administrator',
  Example: 'Sahifa',
  Profile: 'Profil',
  Continue: 'Davom etish',
  Export: 'Eksport',
  CompanyNews: 'Kompaniya yangiliklari',
  CompanyEmployees: 'Kompaniya xodimlari',
  YouCantDisableAllCalendars: 'Barcha kalendarlarni oʻchirish mumkin emas',
  MyCalendars: 'Mening kalendarlarim',
  AddCalendar: "Kalendarni qo'shish",
  AddingEvent: "Hodisani qo'shish",
  AddingCalendar: "Kalendarni qo'shish",
  EditingCalendar: "Kalendarni o'zgartirish",
  StartDateTime: 'Boshlanish sanasi/vaqti',
  FinishDateTime: 'Tugash sanasi/vaqti',
  Resource: 'Resurs',
  Members: 'Ishtirokchilar',
  Member: 'Ishtirokchi',
  Change: "O'zgartirish",
  Close: 'Yopish',
  AreYouSureToDeleteEvent: 'Siz haqiqatan ham shu hodisani o‘chirmoqchimisiz?',
  ThisMemberIsAlreadyInList: 'Bu aʼzo allaqachon roʻyxatda ekan',
  StartDateAndTim: 'Boshlanish sanasi va vaqti',
  FinishDateAndTim: 'Tugash sanasi va vaqti',
  AddMembe: "Ishtirokchini qo'shish",
  CalendarSuccessfullyAdde: "Kalendar muvaffaqiyatli qo'shildi",
  CalendarSuccessfullyDelete: "Kalendar muvaffaqiyatli o'chirildi",
  Active: 'Faol',
  Download: 'Yuklab olish',
  DocumentName: 'Xujjat nomi',
  Blank: 'Shakl',
  SelectMember: 'Ishtirokchini tanlang',
  NewEvent: 'Yangi hodisa',
  Reservation: 'Bron qilish',
  Reference: "Ma'lumotnoma",
  Adding: "Qo'shish",
  Comments: 'Izohlar',
  Blanks: 'Shakllar',
  SearchSubdivision: "Bo'linmani qidirish",
  EmployeeSuccessfullyDeleted: "Xodim muvaffaqiyatli o'chirildi",
  Attachments: "Qo'shimchalar",
  Attachment: "Qo'shimcha",
  ThereAreNoUsers: "Foydalanuvchilar yo'q ekan",
  RowsPerPage: 'Sahifaga qatorlar soni',
  Roles: 'Rollar',
  Users: 'Foydalanuvchilar',
  User: 'Foydalanuvchi',
  UserRoles: 'Foydalanuvchilar rollari',
  RolesList: "Rollar ro'yhati",
  FullName: "To'liq ismi",
  AddingNewReference: "Yangi ma'lumotnomani qo'shish",
  ReferenceSuccessfullyCreated: "Ma'lumotnoma muvaffaqiyatli qo'shildi",
  TableName: 'Jadval nomi',
  LatinLettersAndDigits: 'Lotin harflari va raqamlar',
  References: "Ma'lumotnomala",
  Organizations: 'Tashkilotlar',
  Organization: 'Tashkilot',
  Editing: "O'zgartiris",
  ShortTitle: 'Qisqartirilgan nomi',
  WorkAddress: 'Ish manzili',
  WorkCountry: 'Mamlakat',
  WorkCity: 'Shahar',
  WebPage: 'Veb-sahifa',
  Fax: 'Faks',
  Positions: 'Lavozimlar',
  Position: 'Lavozim',
  Citizenship: 'Fuqarolik',
  Address: 'Manzil',
  Branches: 'Sanoatlar',
  CollapseAll: "Hammasini yig'ish",
  AddStaffPosition: "Lavozimni qo'shish",
  AssignEmployee: 'Xodimni tayinlash',
  AssignManager: 'Boshliqni tayinlash',
  PositionSuccessfullyDeleted: "Lavozim muvaffaqiyatli o'chirildi",
  HrmUsers: 'HRM foydalanuvchilari',
  Confirm: 'Tasdiqlash',
  CalendarSuccessfullyChanged: "Kalendar muvaffaqiyatli o'zgartirildi",
  Actions: 'Harakatlar',
  Rate: 'Xodim',
  StaffTable: 'Xodimlar jadvali',
  RequiredField: 'Majburiy kiritish maydoni',
  PassportSeries: 'Pasport seriyasi',
  Pinfl: 'PINFL',
  Inn: 'INN',
  DeletePosition: "Lavozimini o'chirish",
  No: "Yo'q",
  SubdivisionManager: "Bo'linma boshligi",
  AreYouSureToFireEmployeeFromPosition:
    "Siz haqiqatan ham shu xodimni lavozimidan bo'shatmoqchimisiz?",
  FireEmployeeFromPosition: "Xodimni lavozimidan bo'shatish",
  SortingValue: 'Saralash uchun qiymat',
  Education: "Ta'lim",
  Responsibilities: "Mas'uliyatlar",
  AdditionalRequirements: "Qo'shimcha talablar",
  EmployeeSuccessfullyAssigned: 'Xodim muvaffaqiyatli tayinlandi',
  Employee: 'Xodim',
  PositionName: 'Lavozimning nomi',
  StaffUnits: 'Shtat lavozimlari',
  Total: 'Jami',
  ManagerSuccessfullyAssigned: 'Rahbar muvaffaqiyatli tayinlandi',
  CreateADUser: 'AD foydalanuvchisini yaratish',
  Category: 'Kategoriya',
  Username: 'Foydalanuvchi nomi',
  Search: 'Qidirish',
  OUParent: "Yuqoridagi bo'linma",
  ShowInOrgstructure: "Tashkiliy tuzilmasida ko'rsatish",
  AreYouSureToDeleteRecord: 'Siz haqiqatan ham shu yozuvini o‘chirmoqchimisiz?',
  UserSuccessfullyAdded: "Foydalanuvchi muvaffaqiyatli qo'shildi",
  Surname: 'Familiya',
  Name: 'Ismi',
  Patronymic: 'Otasining ismi',
  PassportNumber: 'Pasport raqami',
  PhoneNumber: 'Telefon raqami',
  Status: 'Status',
  CurrentEmployee: 'Faol xodimi',
  Fired: "Ishdan bo'shatilgan",
  UserStatus: 'Foydalanuvchi statusi',
  Man: 'Erkak',
  Woman: 'Ayol',
  ConnectWithHRM: "HRM bilan bog'lash",
  AddStatus: "Statusni qo'shish",
  Yes: 'Ha',
  SubtaskTitle: 'Quyi vazifa nomi',
  CardTitle: 'Karta nomi',
  Comment: 'Izoh',
  SuccessfullyAdded: "Muvaffaqiyatli qo'shildi",
  Executors: 'Ijrochilar',
  Information: "Ma'lumot",
  InOffice: 'Ofisda',
  NotInOffice: 'Ofisda emas',
  Specialists: 'Mutaxassislar',
  Management: 'Boshliqlar',
  Managers: 'Rahbarlar',
  TechnicalStaff: 'Texnik xodimlar',
  AddAnotherCard: "Boshqa kartani qo'shish",
  YouMustEnterTitle: 'Nomini kiritish kerak',
  ListTitle: "Ro'yxat nomi",
  AddAnotherList: "Boshqa ro'yxatni kiritish",
  MakeCover: 'Qopqoqni yaratish',
  RemoveCover: "Qopqoqni o'chirish",
  RemoveAttachment: "Qo'shimchani o'chirish",
  Link: 'Havola',
  AddItem: "Elementni qo'shing",
  WriteComment: 'Izohni yozing',
  RemoveDueDate: "Tugatish sanasini o'chirish",
  ChooseDueDate: 'Tugatish sanasini tanlash',
  SuccessfullyDeleted: "Muvaffaqiyatli o'chirildi",
  Wait: 'Iltimos kuting',
  ExecutorsSelection: 'Ijrochilarni tanlash',
  Stage: 'Bosqich',
  Phase: 'Faza',
  CurrentPhase: 'Joriy fazasi',
  StartDate: 'Boshlanish sanasi',
  FinishDate: 'Tugash sanasi',
  TaskPriority: 'Vazifa ustuvorligi',
  Priority: 'Ustuvorlik',
  Completed: 'Bajarilgan',
  Files: 'Fayllar',
  ContractNumber: 'Shartnoma raqami',
  ContractDate: 'Shartnoma sanasi',
  Cause: 'Sabab',
  FInancing: 'Moliyalashtirish',
  Amount: 'Jami',
  LinkedProjects: 'Tegishli loyihalar',
  AddContract: "Shartnomani qo'shish",
  NotSpecified: "Ko'rsatilmagan",
  GoToEmployeeChat: "Xodimning chatiga o'tish",
  OwnerSuccessfullyChanged: "Egasi muvaffaqiyatli o'zgartirildi",
  ProjectBranch: 'Loyiha amalga oshirilayotgan sanoat',
  FinancingSide: "To'lov qilayotgan tomoni",
  FinancingType: 'Moliyalashtirish turi',
  EditingContract: "Shartnomani o'zgartirish",
  ProjectSuccessfullyAdded: "Loyiha muvaffaqiyatli qo'shildi",
  ProjectSuccessfullyDeleted: "Loyiha muvaffaqiyatli o'chirildi",
  ContractSuccessfullyDeleted: "Shartnoma muvaffaqiyatli o'chirildi",
  EditContract: "Shartnomani o'zgartirish",
  AreYouSureToDeleteContract: 'Siz haqiqatan ham shu shartnomasini o‘chirmoqchimisiz?',
  DeleteContract: "Shartnomani o'chirish",
  Contract: 'Shartnoma',
  Contracts: 'Shartnomalar',
  EmployeeSuccessfullyAdded: "Xodim muvaffaqiyatli qo'shildi",
  OwnerWasNotChanged: "Egasi o'zgartirilmadi",
  Attention: 'Diqqat',
  AfterChangingOwnerYouWillBecomeExecutor:
    "Egasi o'zgargandan so'ng, ushbu loyihadagi rolingiz avtomatik ravishda \"Ijrochi\"ga o'zgaradi",
  NewOwner: 'Yangi egasi',
  Currency: 'Valyuta',
  Sum: 'Pul miqdori',
  DistributionByProjects: "Loyihalar bo'yicha taqsimlash",
  PaymentSuccessfullyDeleted: "To'lov muvaffaqiyatli o'chirildi",
  AreYouSureToDeletePayment: "Siz haqiqatan ham shu to'lovini o‘chirmoqchimisiz?",
  Payment: "To'lov",
  PhaseSuccessfullySaved: 'Faza muvaffaqiyatli saqlangan',
  TaskTitle: 'Vazifaning nomi',
  TaskDescription: 'Vazifaning tavsifi',
  PhaseTitle: 'Fazaning nomi',
  AddPhase: "Fazani qo'shish",
  Chapter: 'Bob',
  InformationAboutProject: "Loyiha haqida ma'lumot",
  ProjectTitle: 'Loyiha nomi',
  LinkWithOtherProjects: 'Loyihaning boshqa loyihalar bilan aloqasi',
  ProjectInitiator: 'Loyihaning tashabbuskori (buyurtmachisi)',
  TitleAddressPhoneFaxEmail: 'ism, INN, manzil, telefon, faks, elektron pochta',
  ProjectDescription: 'Loyihaning tavsifi',
  ProjectInitiatingCause: 'Loyihani boshlash uchun sabab',
  NewContract: 'Yangi shartnoma',
  Board: 'Doska',
  Chat: 'Сhat',
  ListSuccessfullyAdded: 'Roʻyxat muvaffaqiyatli koʻshildi',
  SubtaskSuccessfullyAdded: 'Quyi vazifa muvaffaqiyatli koʻshildi',
  ProjectEndDate: 'Loyihaning tugash sanasi',
  ProjectContents: 'Loyihaning mazmuni',
  ProjectPassport: 'Loyihaning pasporti',
  FillPassport: "Pasportni to'ldirish",
  ProjectManager: 'Loyiha menejeri',
  OfProjectGroup: 'loyiha guruhining',
  OtherProjectMembers: 'Boshqa loyiha ishtirokchilari',
  Table: 'Jadval',
  List: "Ro'yxat",
  Phases: 'Fazalar',
  MyTasks: 'Mening fazifalarim',
  Payments: "To'lovlar",
  EditProject: "Loyihani o'zgartirish",
  DeleteProject: "Loyihani o'chirish",
  MemberSuccessfullyDeleted: "Ishtirokchi muvaffaqiyatli o'chirildi",
  RoleSuccessfullyChanged: "Rol muvaffaqiyatli o'zgartirildi",
  RoleWasNotChanged: "Rol o'zgartirilmadi",
  RoleInProject: 'Loyihadagi roli',
  MemberWasNotDeleted: "Ishtirokchi o'chirilmadi",
  ChangeOwner: "Egasini o'zgartirish",
  PhaseSuccessfullyDeleted: "Faza muvaffaqiyatli o'chirildi",
  EditPhase: "Fazani o'zgartirish",
  NewPhase: 'Yangi fazasi',
  ListSuccessfullyRelocated: 'Roʻyxat muvaffaqiyatli koʻchirildi',
  ErrorWhileRelocatingList: 'Roʻyxatni koʻchirishda xato',
  TaskSuccessfullyRelocated: 'Vazifa muvaffaqiyatli koʻchirildi',
  Executor: 'Ijrochi',
  AddTask: "Vazifani qo'shish",
  TaskSuccessfullyAdded: 'Vazifa muvaffaqiyatli koʻshildi',
  ProjectSuccessfullyUpdated: "Loyiha muvaffaqiyatli o'zgartirildi",
  Project: 'Loyiha',
  ProjectEditing: "Loyihani o'zgartirish",
  ClosedPlural: 'Bajarilgan',
  ExcludeMember: "Ishtirokchini o'chirish",
  ProjectPurposeAndExpectingResults: 'Loyihaning maqsadi va kutilayotgan natijalari',
  NewProject: 'Yangi loyiha',
  InWork: 'Bajarilmoqda',
  Paused: "To'xtatilgan",
  Rejected: 'Rad etilgan',
  High: 'Yuqori',
  Observer: 'Kuzatuvchi',
  AddEmployee: "Xodimni qo'shish",
  Format: 'Format',
  Department: 'Departament',
  Absent_plural: 'Ish joyida emas',
  EmployeesSummaryReport: "Xodimlarning to'plangan jadvali",
  EarlyLeaving: 'Vaqtli ketish',
  LastWeek: 'Oxirgi hafta',
  LastTwoWeeks: 'Oxirgi 2 hafta',
  CreateTask: 'Vazifani yaratish',
  ProjectStartDate: 'Loyihani boshlanish sanasi',
  AddProject: "Loyihani qo'shish",
  SearchProject: 'Loyihani qidirish',
  Projects: 'Loyihalar',
  Task: 'Vazifa',
  New_female: 'Yangi',
  Closed_female: 'Bajarilgan',
  Planned: 'Rejalashtirilgan',
  Owner: 'Egasi',
  ResponsibleUnderContract: "Shartnoma bo'yicha javobgar",
  Low: 'Past',
  Usual: 'Oddiy',
  Urgent: 'Shoshilinch',
  Responsible: "Mas'ul",
  Producer: 'Postanovkachi',
  ByStaff: "Shtat bo'yicha",
  Employees_genitive: 'Xodimlar soni',
  SubordinatesWorkingHoursCalculation: "Bo'ysunuvchilarning ish vaqtini qayd etish",
  YouDontHaveSubordinates: "Sizda bo'ysunuvchi xodimlar yo'q ekan",
  FIO: 'F.I.O.',
  ShowTable: "Jadvalni ko'rsatish",
  Lateness: 'Kechikish',
  LastThirtyDays: 'Oxirgi 30 kun',
  LastNinetyDays: 'Oxirgi 90 kun',
  SummaryReport: "To'plangan hisoboti",
  PressButtonToCreateTask: 'Vazifani yaratish uchun tugmani bosing',
  Gender: 'Jinsi',
  Departments: 'Departamentlar',
  ChooseStartAndEndDatesForSummaryReport:
    'Xulosa hisoboti uchun boshlanish va tugash sanalarini tanlang',
  PreviousMonth: 'Oldingi oy',
  ProfilePhoto: 'Profilning foto',
  PressButtonBelowToShowTable: "Jadvalni ko'rish uchun quyidagi tugmani bosing",
  PaymentEditingError: "Toʻlovni o'zgartirishda xatolik yuz berdi",
  Translations: 'Tarjimalar',
  ChartsAreNotShowedInMobileDevices: "Grafiklar mobil qurilmalarda ko'rsatilmaydi",
  LateComingsAndEarlyLeavings: 'Kech kelishlar va erta ketishlar',
  Dates: 'Sanalar',
  ViolationsCount: 'Qoidabuzarliklar soni',
  NoData: "Ma'lumotlar yo'q ekan",
  Date: 'Sana',
  Entrance: 'Kirish',
  Exit: 'Chiqish',
  TimeAtWork: 'Ishdagi vaqt',
  Calendar: 'Kalendar',
  WorkingHoursCalculation: 'Ish vaqtini qayd etish',
  Next: 'Keyingi',
  NextMonth: 'Keyingi oy',
  Photo: 'Foto',
  CreationDate: 'Yaratish sana',
  EditContacts: "Kontaktlarni o'zgartirish",
  SearchEmployees: 'Xodimlarni qidirish',
  AddUser: "Foydalanuvchini qo'shish",
  SelectUserStatus: 'Foydalanuvchining statusni tanlang',
  AttachedFiles: 'Biriktirilgan fayllar',
  AttachedFile: 'Biriktirilgan fayl',
  Activity: 'Faoliyat',
  Banner: 'Banner',
  ChangeBanner: "Bannerni o'zgartirish",
  ChangePhoto: "Fotoni o'zgartirish",
  GanttChart: 'Gant diagrammasi',
  AddPayment: "To'lovni qo'shish",
  Prepayment: "Oldindan to'lov",
  PaymentSuccessfullyAdded: "To'lov muvaffaqiyatli qo'shildi",
  PaymentSuccessfullyEdited: "To'lov muvaffaqiyatli o'zgartirildi",
  PaymentAddingError: 'Toʻlovni qoʻshishda xatolik yuz berdi',
  Translation: 'Tarjima',
  WorkingHoursSummaryReport: "Ish vaqtini kuzatishning to'plangan jadvali",
  SaveComment: 'Izohni saqlash',
  FullscreenToggle: "To'liq ekran rejimini almashtirish",
  SearchRole: 'Rolni qidirish',
  EventCreation: 'Tadbir yaratish',
  OUSuccessfullyMovedUp: "Tashkiliy bo'linma muvaffaqiyatli ko'tarildi",
  DoYouReallyWantToDeleteOU: "Siz haqiqatan ham ushbu tashkiliy bo'linmani o'chirmoqchimisiz?",
  SubmitYourRequest: "So'rovingizni yuboring",
  Support: 'Yordam',
  YourRequestWillBeProcessed:
    "Sizning so'rovingiz ko'rib chiqiladi va xodimlarimiz sizga javob beradilar",
  Subject: 'Mavzu',
  Submit: 'Yuborish',
  Message: 'Xabar',
  EnterRoleForSearching: 'Qidirish uchun rolni kiriting',
  AddRole: "Rolni qo'shish",
  ClickButtonToAddRole: "Rolni qo'shish uchun tugmani bosing",
  ReserveResource: 'Resursni bron qilish',
  PressAndSwipeMouseButtonDownToReserve:
    "Agar siz bron qilichmoqchi bo'lsangiz sichqonchani belgilab suring",
  PressMouseToDate: 'Hodisa yaratish uchun kerakli sanani bosing',
  PressHereToChangeBanner: "Bannerni o'zgartirish uchun ushbu tugmani bosing",
  EditProfile: "Profilni o'zgartirish",
  PressHereToEditProfile: "Profilni o'zgartirish uchun ushbu tugmani bosing",
  PressHereToChangePassword: "Parolni o'zgartirish uchun ushbu tugmani bosing",
  EnterOnlyLatinLettersAndDigits: 'Faqat lotin harflari va raqamlarini kiriting',
  AreYouSureToDeletePosition: 'Siz haqiqatan ham shu lavozimini o‘chirmoqchimisiz?',
  ParticipationInProjects: 'Loyihalarda ishtirok etish',
  AreYouSureToDeleteTicket: 'Siz haqiqatan ham shu tiketni o‘chirmoqchimisiz?',
  AreYouSureToDeleteProject: 'Siz haqiqatan ham shu loyihani o‘chirmoqchimisiz?',
  PressShiftButtonAndScrollMouseWheel:
    "To'plangan jadvalini ko'rsatish uchun tugmani bosing. Jadvalni gorizontal ravishda aylantirish uchun (o'ngdan chapga) klaviaturadagi \"Shift\" tugmasi va sichqonchaning aylantirish g'ildiragi kombinatsiyasidan foydalaning",
  AddSubtask: "Quyi vazifani qo'shish",
  WrongMoneyDistributionByProjects: "Pul miqdori loyihalarga noto'g'ri ajratilgan ",
  FeedbackForm: 'Fikr-mulohaza shakli',
  SearchProjects: 'Loyihalarni qidirish',
  EnterProjectNameToFindIt: 'Qidirish uchun loyiha nomini kiriting',
  Backward: 'Orqaga',
  Further: 'Oldiga',
  EditOrganization: "Tashkilotni o'zgartirish",
  AddOrganization: "Tashkilotni qo'shish",
  GroupInformation: "Guruh haqida ma'lumotlar",
  ContactInformation: "Kontakt haqida ma'lumotlar",
  AddUsersToGroup: "Foydalanuvchilarni guruhga qo'shish",
  NoNews: "Yangililar yo'q ekan",
  FeedbackSuccessfullyAdded: "So'rovingiz muvaffaqiyatli qabul qilindi",
  ErrorAddingFeedback: "So'rovingiz qabul qilinmadi",
  Previous: 'Oldingi',
  EditSkills: "Ko'nikmalarni o'zgartirish",
  HRDepartmentResponsibilities:
    "Ish bilan ta'minlash masalalari, ish guvohnomasi, xizmat safari, ta'til, kasallik ta'tillari ...",
  AlsoProjectInitiationCauseLegalAct:
    "shu jumladan loyihani boshlash uchun asos bo'lgan normativ-huquqiy hujjat",
  Subtasks: 'Quyi vazifalar',
  PressHereToEditContacts: "Kontaktlarni o'zgartirish uchun ushbu tugmani bosing",
  EndDateMustBeGreaterThanStartDate: "Tugash sanasi boshlanish sanasidan kechroq bo'lishi kerak",
  Private: 'Shaxsiy',
  Presentations: 'Taqdimotlar',
  SelectConversationOrStartNewChat: 'Suhbatni tanlang yoki yangi suhbatni boshlang',
  Birthday: "Tug'ilgan kuni",
  Send: "Jo'natish",
  ParticipantsCount: 'Ishtirokchilar soni',
  PressHereToAddProject: "Loyiha qo'shish uchun shu yerni bosing",
  ContractPayment: "Shartnoma bo'yicha to'lov",
  ContractPrepayment: "Shartnoma bo'yicha oldindan to'lov",
  AdditionalAgreement: "Qo'shimcha kelishuv",
  AdditionalAgreements: "Qo'shimcha kelishuvlar",
  NoAdditionalAgreements: "Qo'shimcha kelishuvlar mavjud emas",
  PaymentDate: "To'lov sanasi",
  AddProjectToContract: "Shartnomaga loyihani qo'shish",
  NewsSuccessfullyAdded: 'Yangilik muvaffaqiyatli qo‘shildi',
  InProgress: 'Jarayonda',
  TasksInProgress: 'Jarayondagi vazifalar',
  ClosedTasks: 'Bajarilgan vazifalar',
  ClosedTasksList: "Bajarilgan vazifalar ro'yxati",
  PressButtonToAddContract: "Shartnomani qo'shish uchun tugmani bosing",
  PausedTasks: "To'xtatilgan vazifalar",
  PausedTasksList: "To'xtatilgan vazifalar ro'yxati",
  RejectedTasks: 'Rad etilgan vazifalar',
  RejectedTasksList: "Rad etilgan vazifalar ro'yxati",
  ScheduledTasks: 'Rejalashtirilgan vazifalar',
  ScheduledTasksList: "Rejalashtirilgan vazifalar ro'yxati",
  SelectMonth: 'Oyni tanlang',
  SelectMonthRestrictionsInCalendar:
    "Oyni tanlang, kalendar rejimida oy tanlashda cheklovlar bo'lishi mumkin",
  SelectTodayButton: 'Bugun tanlash tugmasi',
  PressToJumpToday: "Bugungi kunga o'tish uchun bu tugmani bosing",
  ViewSelection: "Ko'rinishni tanlash",
  SelectCalendarOfTableView:
    "Kalendar yoki jadval ko'rinishini tanlang. Kalendarda faqat joriy oy to'g'ri ko'rsatiladi",
  BeginAndEndDates: 'Boshlanish va tugash sanalari',
  SearchDepartments: "Bo'linmalarni qidirish",
  AddingDepartment: "Bo'linmani kiritish",
  PressButtonForAddingDepartment: "Bo'lim qo'shish uchun tugmani bosing",
  EnterDepartmentForSearching: "Qidirish uchun bo'linma nomini kiriting",
  PressButtonForAddingPosition: "Lavozimni qo'shish uchun tugmani bosing",
  WithoutViolations: 'Qoidabuzarliklarsiz',
  ClickButtonToCollapseAllDepartments: "Barcha bo'linmalarni yopish uchun tugmani bosing",
  AddPosition: "Lavozimni qo'shish",
  Scale: 'Masshtab',
  Day: 'Kun',
  Week: 'Hafta',
  Month: 'Oy',
  Year: 'Yil',
  AddingUser: "Foydalanuvchini qo'shish",
  LateComingsAndEarlyLeavingsForOneWeekCharts:
    'Oxirgi haftaning kech kelishlar va erta ketishlar grafigi',
  RoleTitle: 'Rol nomi',
  PressButtonToAddMembers: "Ishtirokchini qo'shish uchun tugmani bosing",
  AddMembers: "Ishtirokchilarnini qo'shish",
  Latenesses: 'Kechikishlar',
  SendFile: "Faylni jo'natish",
  HorizontalScrolling: 'Gorizontal aylantirish',
  CantCreateEventInPast: 'O‘tgan sana/vaqt uchun hodisani yaratish mumkin emas',
  Subdivision: "Bo'linma",
  ShortName: 'Qisqa nomi',
  WorkPhone: 'Ish joyi telefoni',
  UserSuccessfullyRemovedFromGroup: "Foydalanuvchi guruhdan muvaffaqiyatli o'chirildi",
  ErrorRemovingUserFromGroup: "Foydalanuvchini guruhdan o'chirganda xatolik yuz berdi",
  ForHorizontalScrollPressShiftAndRollMouseWheel:
    "Gorizontal aylantirish uchun Shift tugmasini bosib sichqonchaning g'ildiragini aylantiring",
  ProjectOwner: 'Loyihaning egasi',
  Filters: 'Filtrlar',
  ResetAll: "Hammasini o'chirish",
  EndDate: 'Tugash sanasi',
  TicketSuccessfullySaved: 'Vazifa muvaffaqiyatli saqlangan',
  TicketWasntSaved: 'Vazifa saqlanmagan',
  Observers: 'Kuzatuvchilar',
  ObserversSelection: 'Kuzatuvchilarni tanlash',
  Closed: 'Bajarilgan',
  WorkloadIndicators: "Ish yuki ko'rsatkichlari",
  StatisticsByTasks: 'Vazifalar statistikasi',
  ChooseSkills: "Ko'nikmalarni tanlang",
  Skill: "Ko'nikma",
  PressHereToEditSkills: "Ko'nikmalarni o'zgartirish uchun ushbu tugmani bosing",
  NoNotifications: 'Bildirishnomalar mavjud emas',
  NewPlural: 'Yangi',
  EventSuccessfullyDeleted: "Hodisa muvaffaqiyatli o'chirildi",
  AreYouSureToDeleteMember: "Siz haqiqatan ham shu ishtiroqchini ro'yxatdan o‘chirmoqchimisiz?",
  FiltersAreDisabled: "Filtrlar o'chirilgan",
  StartDateCannotBeBiggerThanEndDate: 'Boshlanish sanasi tugash sanasidan oshmasligi kerak',
  FileNotFound: 'Fayl topilmadi',
  FileName: 'Fayl nomi',
  AddFile: "Faylni qo'shish",
  DeleteFile: "Faylni o'chirish",
  FloorEditing: 'Qavatni tahrirlash',
  AreYouSureToDeleteFile: 'Siz haqiqatan ham shu faylni o‘chirmoqchimisiz?',
  MyProjects: 'Mening loyihalarim',
  MyAttendance: 'Mening davomatim',
  OnlyMembersCanChangeEvent: "Faqat a'zolar tadbirni o'zgartirishi mumkin",
  NoPermissionsForCreatingNewEvent: 'Sizda yangi hodisani yaratish uchun vakolatlar yetarli emas',
  Finished: 'Tugatilgan',
  RequestDataFromHRM: "HRMdan ma'lumotlarni so'rash",
  ErrorOccuredOpenBrowserConsole:
    "Xatolik yuz berdi. Xato tafsilotlarini ko'rish uchun brauzer konsolingizni oching",
  DataSuccessfullyReceived: 'Maʼlumotlar muvaffaqiyatli qabul qilindi',
  DataWasNotReceived: 'Maʼlumotlar qabul qilinmadi',
  DataSuccessfullyUpdated: 'Maʼlumotlar muvaffaqiyatli yangillandi',
  Mode: 'Rejim',
  EditMode: 'Tahrirlash rejimi',
  Sandbox: 'Qum qutisi',
  TechSupportDepartmentResponsibilities:
    "Tarmoq, tizim administratori, dasturiy ta'minotni o'rnatish...",
  Building: 'Bino',
  Buildings: 'Binolar',
  Floor: 'Qavat',
  Floors: 'Qavatlar',
  AddDepartment: "Bo'linmani qo'shish",
  AddBuilding: "Bino qo'shish",
  AddFloor: "Qavat qo'shish",
  BuildingEditing: 'Binoni tahrirlash',
  SelectDepartments: "Bo'linmalarni tanlash",
  PleaseUploadImage1280x980pixels:
    "Iltimos, uzunligi 1280 px va balandligi 980 px bo'lgan rasm yuklang!!!",
  Offices: 'Ofislar',
  AddPhoto: "Rasm qo'shish",
  CreatorsAreAddedToMembersAutomatically:
    "Siz tadbir yaratuvchisiz va avtomatik ravishda ishtirokchilarga qo'shilasiz",
  EditPhoto: "Rasm o'zgartirish",
  DownloadMobileApplication: 'Mobil ilovani yuklab olish',
  InFewDays: 'Yaqin kunlarda',
  BuildingsDontExist: 'Binolar mavjud emas',
  ChatInitialization: 'Chat ishga tushmoqda',
  FloorsDontExist: 'Qavatlar mavjud emas',
  PleaseEnterLetter: 'Iltimos. harf kiriting',
  EditFloor: 'Qavatni tahrirlash',
  Logs: 'Loglar',
  NewsSuccessfullyEdited: "Yangilik muvaffaqiyatli o'zgartirildi",
  EditPost: 'Yangilikni tahrirlash',
  Port: 'Port',
  New: 'Yangi',
  YouNeedToExecuteTheTask: 'Siz vazifani bajarishingiz kerak',
  TasksYouAreCurrentlyDoing: 'Siz hozir bajarayotgan vazifalar',
  YouExecutedTasks: 'Siz bajargan vazifalar',
  Quantity: 'Miqdor',
  ClaimTypes: "So'rovlar turlari",
  OnTime: 'Vaqtida',
  AddClaimType: "So'rov turini qo'shish",
  EditClaimType: "So'rov turini o'zgartirish",
  ClaimTypeSuccessfullyUpdated: "So'rov turi muvaffaqiyatli yangillandi",
  ClaimTypeSuccessfullyAdded: "So'rov turi muvaffaqiyatli qo'shildi",
  ClaimTypeSuccessfullyDeleted: "So'rov turi muvaffaqiyatli o'chirildi",
  AreYouSureToDeleteClaim: "Siz haqiqatan ham shu so'rovni o‘chirmoqchimisiz?",
  EditClaimExecutor: "So'rov ijrochini o'zgartirish",
  ClaimStatuses: "So'rov holatlari",
  ClaimStatusSuccessfullyDeleted: "So'rov holati muvaffaqiyatli o'chirildi",
  ClaimStatusSuccessfullyUpdated: "So'rov holati muvaffaqiyatli yangillandi",
  ClaimStatusSuccessfullyAdded: "So'rov holati muvaffaqiyatli qo'shildi",
  ClaimExecutorSuccessfullyAdded: "So'rov ijrochi muvaffaqiyatli qo'shildi",
  ClaimExecutorSuccessfullyUpdated: "So'rov ijrochi muvaffaqiyatli yangillandi",
  ClaimExecutorSuccessfullyDeleted: "So'rov ijrochi muvaffaqiyatli o'chirildi",
  AddClaimExecutor: "So'rov ijrochini qo'shish",
  ClaimSuccessfullyExecuted: 'So‘rov muvaffaqiyatli bajarildi',
  ClaimExecutors: "So'rovlar ijrochilari",
  ClaimType: "So'rov turi",
  Type: 'Tur',
  Guid: 'GUID',
  NoTemplateFields: "Shablon maydonlari yo'q",
  Execute: 'Bajarish',
  Reject: 'Rad qilish',
  CloseWindow: 'Oynani yopish',
  SuccessfullySaved: 'Muvaffaqiyatli saqlanildi',
  Defer: 'Kechiktirish',
  StartExecution: 'Bajarishni boshlash',
  ClaimsProcessing: "So'rovlarni qayta ishlash",
  ClaimProcessing: "So'rovni qayta ishlash",
  Creator: 'Yaratuvchi',
  MyEntriesAndExits: '	Mening kirish/chiqishlarim',
  AddProjectStatus: "Loyiha holatini qo'shish",
  DoesNotExistInHRM: "Foydalanuvchi HRM ro'yxatida topilmadi",
  YouDontHaveClaims: "Sizda so'rovlar yo'q",
  InExecution: 'Bajarishda',
  OnAgreement: 'Kelishuvda',
  OnApproval: 'Tasdiqlashda',
  Defered: 'Qoldirilgan',
  Closed_male: 'Bajarilgan',
  CleanFilters: 'Filtrlarni tozalash',
  ImpossibleToIdentify: 'Aniqlash mumkin emas',
  Filter: 'Filtr',
  NoClaims: "So'rovlar yo'q",
  Content: 'Mazmun',
  Greeting: 'Salom',
  Start_verb: 'Boshlash',
  All: 'Hammasi',
  ForwardToNewAchievements: 'Yangi yutuqlar sari intiling',
  PhotoNotFound: 'Rasm topilmadi',
  GladToSeeYouInOurTeam: "Sizni jamoamizda ko'rganimizdan xursandmiz",
  YourEnergyAndTalentWillBecomeContribution:
    "Sizning kuchingiz va istedodingiz umumiy ishimizga bebaho hissa bo'ladi",
  PhotoSuccessfullyUpdated: 'Rasm muvaffaqiyatli yangilandi',
  HrmEmployees: 'HRM xodimlari',
  ConnectWithUser: "Foydalanuvchiga bog'lash",
  UpdatePhotoFromHrm: 'HRMdan rasmni yangilash',
  LinkedWithUsers: "Foydalanuvchilar bilan bog'langan",
  AdUsers: 'AD foydalanuvchilari',
  Сomplaint: 'Shikoyat',
  QuestionToGeneralDirector: 'Bosh direktorga savol',
  PortalTechSupport: "Portalni texnik qo'llab-quvvatlash",
  NotLinked: "Bog'lanmagan",
  Linked: "Bog'langan",
  AdUser: 'AD foydalanuvchi',
  LateComingsAndEarlyLeavingsCharts: 'Kech kelishlar va erta ketishlar',
  SelectRoles: 'Rollarni tanlang',
  Reply: 'Javob berish',
  FileSuccessfullyDeleted: "Fayl muvaffaqiyatli o'chirildi",
  TaskName: 'Vazifa nomi',
  UnbindFromAdAccount: 'AD akkauntidan aloqani uzish',
  AreYouSureToUnbindEmployeeFromAdAccount:
    'Siz haqiqatan ham shu xodimni AD akkauntidan uzishnini xohlaysizmi?',
  AdAccountSuccessfullyUnbinded: 'AD akkaunti muvaffaqiyatli uzildi',
  ConnectWithAdAccount: "AD akkaunti bilan bog'lash",
  HappyBirthday: 'Tug`ilgan kuningiz bilan',
  SelectPhase: 'Fazani tanlang',
  TaskNumberCopiedToClipboard: "Vazifa raqami almashish buferiga ko'chirildi",
  TaskNumber: 'Vazifa raqami',
  PressToCopy: "Ko'chirish uchun bosing",
  Follow: "O'tish",
  ThereAreNoEmployees: "Xodimlar yo'q",
  FirstEntranceInADay: 'Belgilangan kunidagi birinchi kirish',
  LastExitInADay: 'Belgilangan kunidagi oxirgi chiqish vaqti',
  PressOnDateButton: 'Sana bilan tugmasini bosing',
  ForDetailedView: "batafsil ko'rish uchun",
  Text: 'Matn',
  FirstEntrance: 'Birinchi kirish',
  LastExit: 'Oxirgi chiqish',
  DirectSubordination: "To'g'ridan-to'g'ri bo'ysunish",
  ChangeProjectOwner: "Loyiha egasini o'zgartirish",
  NoRecordsForThatDay: "Ma'lumotlar yo'q ekan",
  PressOnRequiredDate: 'Kerakli sanaga bosing',
  GroupName: 'Guruh nomi',
  Vacation: "Ta'til",
  SickLeave: "Kasallik ta'til",
  MyClaims: "Mening so'rovlarim",
  AbsenceAsksStatuses: 'Ishdan javob olish statuslari',
  AddAbsenceAskStatus: "Javob olish statusni qo'shish",
  EditAbsenceAskStatus: "Ishdan javob olish statusni o'zgartirish",
  AbsenceAsksCategories: 'Ishdan javob olish kategoriyalari',
  AddAbsenceAskCategory: "Javob olish kategoriyani qo'shish",
  EditAbsenceAskCategory: "Javob olish kategoriyani o'zgartirish",
  AbsenceAsksStatusSuccessfullyUpdated: "Ishdan javob olish statusi muvaffaqiyatli o'zgartirildi",
  AbsenceAsksStatusSuccessfullyAdded: "Ishdan javob olish statusi muvaffaqiyatli qo'shildi",
  AbsenceAsksCategorySuccessfullyUpdated:
    "Ishdan javob olish kategoriyasi muvaffaqiyatli o'zgartirildi",
  AbsenceAsksCategorySuccessfullyAdded: "Ishdan javob olish kategoriyasi muvaffaqiyatli qo'shildi",
  AbsenceAsksSubCategories: 'Ishdan javob olish quyi kategoriyalari',
  AbsenceAskSuccessfullyAdded: "Ishdan javob olish muvaffaqiyatli qo'shildi",
  PositionCategory: 'Lavozim kategoriyasi',
  FromTime: 'Qaysi vaqtdan',
  ToTime: 'Qaysi vaqtgacha',
  Approve: 'Tasdiqlash',
  From: 'Dan',
  Until: 'Gacha',
  Chief: 'Rahbar',
  Subcategory: 'Quyi kategoriya',
  AddAbsenceAskSubcategory: "Javob olish quyi kategoriyani qo'shish",
  EditAbsenceAskSubcategory: "Javob olish quyi kategoriyani o'zgartirish",
  AbsenceAskSubcategorySuccessfullyUpdated:
    "Ishdan javob olish quyi kategoriyasi muvaffaqiyatli o'zgartirildi",
  AbsenceAskSubcategorySuccessfullyAdded:
    "Ishdan javob olish quyi kategoriyasi muvaffaqiyatli qo'shildi",
  StartDateCanNotBeLaterThanEndDate: 'Tugash sanasi boshlanish sanasidan oshmasligi kerak',
  YouCanCreateLeaveRequestOnlyForThreeDays:
    "Ishdan ruxsat olish so'rovni faqat 3 kun oldin yaratishingiz mumkin",
  FillNewsText: "Yangilik matnini to'ldiring",
  NewsSuccessfullyDeleted: "Yangilik muvaffaqiyatli o'zgartirildi",
  NewTasks: 'Yangi vazifalar',
  ThereAreThreeDaysIntervalFromCurrentDate:
    "So'rovning boshlanish sanasi joriy kundan 3 kundan ortiq farq qilishi mumkin emas",
  NoRecordsForSelectedTimeInterval: "Tanlangan vaqt oralig'i uchun hech qanday yozuvlar yo'q",
  TasksList: "Vazifalar ro'yxati",
  DataNotFound: 'Maʼlumotlar topilmadi',
  NoPermissionsForCreatingNewRecord: 'Sizda yangi yozuvni yaratish uchun vakolatlar yetarli emas',
  RecordSuccessfullyAdded: "Yozuv muvaffaqiyatli qo'shildi",
  ErrorOccuredWhileAddingRecord: "Yozuvni qo'shish jarayonida xatolik yuz berdi	",
  OnlyMembersCanChangeRecord: "Faqat a'zolarga yozuvni o'zgartirishga ruxsati bor",
  RecordSuccessfullyUpdated: 'Yozuv muvaffaqiyatli yangillandi',
  ErrorOccuredWhileUpdatingRecord: "Yozuvni o'zgartirganda xatolik yuz berdi",
  CantCreateRecordInPast: 'O‘tgan sanaga yozuvni yaratish mumkin emas',
  RecordSuccessfullyDeleted: "Yozuv muvaffaqiyatli o'chirildi",
  ManagerName: 'Rahbar',
  WorkloadByTasks: "Vazifalar bo'yicha ish yuki",
  Attendance: 'Davomat',
  TaskSuccessfullySaved: 'Vazifa muvaffaqiyatli saqlanildi',
  ErrorWhileSavingTask: 'Vazifani saqlashda xatolik yuz berdi',
  YouHaveNoCalendarsYet: "Sizda kalendar yo'q. Bitta kalendarni yarating, iltimos.",
  ChooseCalendarIfNoCalendarCreateIt:
    "Kalendarni tanlang. Agar sizda kalendar bo'lmasa - yarating.",
  TopManager: 'Top menejer',
  TopManagerSecretary: 'Top menejerning kotibi',
  AddTopManagerAndSecretary: "Top menejer va kotibni qo'shish",
  NotAssigned: 'Tayinlanmagan',
  Secretary: 'Kotib',
  ChooseSecretary: 'Kotibni tanlash',
  ChooseTopManager: 'Top menejerni tanlash',
  TopManagers: 'Top menejerlar',
  MyAppointments: 'Qabuliga yozilishlarim',
  Appointments: 'Qabulga yozishlari',
  Time: 'Vaqt',
  View: "Ko'rish",
  'Rad qilish': 'Rad qilish',
  Waiting: 'Kutish',
  ApproveAppointment: 'Uchrashuvni tasdiqlash',
  EnterAppointmentWaitingReason: 'Uchrashuvni kutish sababini kiriting',
  RejectAppointment: 'Yozuvni rad qilish',
  EnterAppointmentRejectReason: 'Qabuliga yozilishni rad etish sababini kiriting',
  Reason: 'Sabab',
  SendToReApprovement: "Qayta tasdiqlashga jo'natish",
  EnterAppointmentReApprovementReason: 'Qabul yozilishni qayta tasdiqlashga sababini kiriting',
  StatusSetToOnApproval: "'Tasdiqlashda' status o'rnatildi",
  WaitingMode: 'Kutish rejimi',
  NoFiles: "Fayllar yo'q ekan",
  AddFiles: "Fayllarni qo'shish",
  Claim: "So'rov",
  AreYouSureToDeleteMessage: 'Siz haqiqatan ham shu xabarni o‘chirmoqchimisiz?',
  AreYouSureToDeleteChat: "Siz haqiqatan ham shu chatni o'chirmoqchimisiz?",
  edited: "o'zgartirilgan",
  AndLeftGroup: 'Va guruhni tark etish',
  NotFound: 'Topilmadi',
  AttachFile: 'Faylni biriktirish',
  ProjectStatuses: 'Loyihalar holatlari',
  ProjectStatusSuccessfullyDeleted: "Loyiha holati muvaffaqiyatli o'chirildi",
  AreYouSureToDeleteProjectStatus: 'Siz haqiqatan ham shu loyiha holatini o‘chirmoqchimisiz?',
  EditProjectStatus: "Loyiha holatini o'zgartirish",
  ProjectStatusSuccessfullyUpdated: 'Loyiha holati muvaffaqiyatli yangillandi',
  ProjectStatusSuccessfullyAdded: "Loyiha holati muvaffaqiyatli qo'shildi",
  Unknown: "Noma'lum",
  MaxFileSizeExceeded: 'Fayl hajmi oshib ketdi',
  AddingVideoConference: "Videokonferentsiyani qo'shish",
  Join: "Qo'shilish",
  Stop: "To'xtatish",
  EditingVideoConference: 'Videokonferentsiyani tahrirlash',
  ErrorOccuredWhileCreatingVideoconference: 'Videokonferentsiya yaratishda xatolik yuz berdi',
  NoTasks: "Vazifalar yo'q",
  SearchByTask: "Vazifa bo'yicha qidirish",
  EarlyLeavingAndLatenesses: 'Erta ketishlar va kech kelishlar',
  LateComeAndEarlyLeavings: 'Kech kelish va erta ketish',
  LateComeAndEarlyLeaving: 'Kech kelish va erta ketish',
  Statistics: 'Statistika',
  ChooseAnotherFile: 'Boshqa faylni tanlang',
  IfNecessary: "Agar kerak bo'lsa",
  File: 'Fayl',
  FileNotSelected: 'Fayl tanlanmagan',
  EditFile: 'Faylni tahrirlash',
  AddClaim: "So'rovni qo'shish",
  MemoryAndHonors: 'Xotira va hurmat',
  InvalidEmailFormat: 'Elektron pochta formati noto‘g‘ri',
  Values: 'Qadriyatlar',
  Subtask: 'Quyi vazifa',
  AddLogo: "Logotip qo'shish",
  Faithful: 'Fidoiylar',
  AreYouSureToDeleteSkill: "Siz haqiqatan ham shu ko'nikmani o‘chirmoqchimisiz?",
  AreYouSureToDeleteNews: 'Siz haqiqatan ham shu yangilikni o‘chirmoqchimisiz?',
  ChooseFile: 'Faylni tanlang (maksimum {{size}}MB)',
  DocumentSize: 'Hujjat hajmi',
  NoContracts: "Shartnomalar yo'q",
  TaskNotFoundMightBeChanged: 'Kechirasiz, ushbu vazifa endi mavjud emas.',
  Open: 'Ochish',
  TaskDetails: 'Vazifa tafsilotlari',
  ScanApplicationDomain: 'Ilova domenini skanerlash',
  AfterDownloading: 'Yuklab olingandan keyin',
  ScanUsingUportalApp: 'uPortal ilova orqail skan qiling',
  AddPhoneType: 'Telefon raqam turini qo‘shish',
  phoneTypes: 'Telefon raqam turlari',
  InvalidPhoneNumberFormat: 'Telefon raqam formati noto‘g‘ri, +998XXYYYYYYY shu formatda kiriting',
  PhoneRequired: 'Telefon raqamini kiritishingiz kerak',
  OnlyDigits: 'Faqat raqam kiriting',
  MinSevenDigits: 'Kamida 7 ta raqam kiriting',
  EnterValidEmail: 'Yaroqli elektron manzil kiriting',
  TheMessageFieldIsRequired: 'Mazmun maydoni majburiy',
  MyAppointmentFormCategoryValidation: 'Turni tanlash majburiy',
  TheSubjectFieldIsRequired: 'Mavzu maydoni majburiy',
  LeaveComment: 'Izoh qoldiring',
  ChooseDate: 'Sanani tanlang',
  ChooseSubcategory: 'Subkategoriyani tanlang',
  DeleteGroupAndLeftGroup: 'Siz ushbu guruhni tark etishni xohlaysizmi?',
  DeleteChat: ' Siz chatni o‘chirib tashlashni xohlaysizmi?',
  e: 'e',
  'Project management': 'Loyihalar boshqaruvi',
  Appointment: 'Uchrashuv',
  TypeIsAlreadyInUse: 'Tur allaqachon ishlatilingan',
  EmptyInput: "Maydon bo'sh bo'lmasligi kerak",
  TypeIsAlreadyInUse121212: 'sd',
  223: ' 23  534',
  TypeIsAlreadyInUse1212121212: 'wefewe',
  44: '444',
  444: 'wq',
  AreYouSureToDeleteTranslation: 'Siz haqiqatan ham shu tarjimani o‘chirmoqchimisiz?',
  TranslationSuccessfullyDeleted: "Tarjima muvaffaqiyatli o'chirildi",
  TypeIsAlreadyInUse12121212121212121212: '324342',
  TypeIsAlreadyInUse12: '2345',
  EnterAValidURL: 'Yaroqli URL kiriting',
  HelpDesk: 'Yordam xizmati',
  EnterAValidPhoneNumber: 'To‘g‘ri telefon raqam kiriting',
  Security: 'Xavfsizlik',
  Notifications: 'Bildirishnomalar',
  AreYouSureToDeleteBuilding: "Siz shu binoni o'chirmoqchimisiz",
  AreYouSureToDeleteFloor: "Siz shu qavatni o'chirmoqchimisiz",
  YouDonTSubmitSymbolOrEmptySpace: 'Guruh nomi harf bilan boshlanishi kerak',
  AreYouSureToDeleteTopManager: 'Siz shu top menejerni o‘chirmoqchimisiz',
  ThisRoleAlreadyExist: 'Bu rol oldin yaratilgan',
  AreYouSureToDeletePhase: 'Faza o‘chirishga ishonchingiz komilmi?',
  InvalidDate: 'To‘liq sanani belgilang',
  NoPosition: 'Lavozim yo‘q',
  NoDepartment: 'Bo‘lim yo‘q',
  EndEvent: 'Tugatish',
  CodeAlreadyExists: 'Bu kod oldindan mavjud',
  isActiveAD: 'Faol AD',
  NoConferences: 'Konferensiyalar yo‘q',
  Code: 'Kod',
  SelectDateRange: 'Sana oralig‘ini tanlang',
  NoOptions: 'Hech narsa topilmadi',
  FloorOrder: 'Qavat tartibi',
  StatusRequired: 'Statusni tanlang',
  Assignee: 'Topshirilgan shaxs',
  StartEndTimeError: 'Tugash vaqti boshlanish vaqtidan keyinroq bo‘lishi kerak',
  Unavailablefiletype: 'Bu fayl turi qo‘llab-quvvatlanmaydi',
  NoBuilding: "Bino yo'q",
  Reception: 'Qabulxona',
  Column: 'Ustun',
  HelpForWork: 'Ish uchun yordam',
  NoFloor: "Qavat yo'q",
  Rename: "Nomni o'zgartirish",
  ChooseDepartments: 'Bo‘limlarni tanlang',
  SkillImageIsRequired: 'Rasm yuklash majburiy',
  Create: 'Yaratish',
  RenameGroup: "Guruh nomini o'zgartirish",
  FailedToUpdateGroupName: 'Guruh nomini o‘zgartirish amalga oshmadi',
  GroupNameUpdatedSuccessfully: 'Guruh nomi muvaffaqiyatli yangilandi',
  VideoCall: "Video qo'ng'iroq",
  CannotSendSpace: 'Bo‘sh joy yuborib bo‘lmaydi',
  Ended_female: 'Tugatilgan',
  NoDepartments: "Departamentlar yo'q",
  ProjectDirector: 'Loyiha direktori',
  NoProject: 'Loyiha mavjud emas',
  Location: 'Joylashuv',
  ConferenceSuccessfullyStoped: 'Konferensiya muvaffaqiyatli yakunlandi',
  NotActiveHRM: 'Faol HRM emas',
  ActiveHRM: 'Faol HRM',
  NoDataAvailable: "Ma'lumot topilmadi",
  NoClaimExecuters: "So'rov ijrochisi mavjud emas",
  InvitationToVideoConference: 'Videokonferentsiyaga taklif',
  Videoconferences: 'Videokonferentsiyalar',
  Videoconference: "Video qo'ng'iroq",
  Loading: 'Yuklanmoqda',
  FilterEnabled: 'Filterlash yoqilgan',
  FilterDisabled: 'Filterlash o‘chirilgan',
  StatusRejected: 'Rad etildi',
  AreYouSureToDeleteAppointmentType: 'Siz haqiqatan ham shu uchrashuv turini o‘chirmoqchimisiz',
  Manager: 'Menejer',
  Approved: 'Tasdiqlandi',
  CreatedDate: 'Yaratilgan sana',
  RoleSuccessfullyDeleted: 'Rol muvaffaqiyatli o‘chirildi',
  RoleSuccessfullyAdded: 'Rol muvaffaqiyatli qo‘shildi',
  Error: 'Xato',
  Excusme: 'Kechirasiz',
  AnErrorOccurred: 'Xatolik yuz berdi',
  AnUnexpectedErrorOccurredInTheSystem: 'Tizimda kutilmagan xatolik yuz berdi',
  ReturnToTheHomepage: 'Bosh sahifaga qaytish',
  UserRoleNot:
    'Tizim bilan ishlash uchun sizda yetarli ruxsat yoʻq. Iltimos, administratorga murojaat qiling',
  ClaimId: "So'rov id",
  AreYouSureToDeleteRole: 'Siz haqiqatan ham shu rolni o‘chirmoqchimisiz?',
  MyAppointmentReason: 'Sabab',
  MyAppointmentGoal: 'Maqsad',
  ErrorWhileSaving: 'Bu xodim allaqon top menejer',
  ErrorWhileRelocatingTask: "Taskni (closed) qilish uchun sub-task bo'lsa uni yopish kerak oldin.",
  'StaffId already taken': "Bu staff ID li user allaqachon bog'langan.",
  ThisEmloyeAlreadyAssignedUser: 'Ushbu xodim allaqachon foydalanuvchiga biriktirilgan',
  Sender: 'Yuboruvchi',
  Print: 'Chop etish',
  IncomingDocuments: 'Kiruvchi hujjatlar',
  ChooseApplication: 'Ariza turini tanlang',
  CreateApplication: 'Ariza yaratish',
  Published: 'Nashr etilgan',
  Back: 'Orqaga',
  NotPublished: 'Nashr etilmagan',
  TemplateSuccessfullyCreated: 'Shablon muvaffaqiyatli yaratildi',
  ToWhomIsAddressed: 'Kimga qaratilgan?',
  Application: 'Ariza',
  ApplicationBody: 'Ariza matni',
  DocumentDate: 'HujjatSanasi',
  ApproversList: "Tasdiqlovchilar ro'yxati",
  ApproverSignature: 'Tasdiqlovchining imzosi',
  TextField: 'Matn maydoni',
  SelectFromList: 'Roʻyxatdan tanlang',
  Number: 'Raqam',
  RejectTemplate: 'Shablonni rad qilish',
  EnterTemplateRejectReason: 'Shablonni rad etish sababini kiriting',
  ApproversSignatures: 'Tasdiqlovchilar imzolari',
  UnPublish: 'Nashrni bekor qilish',
  PropertiesEditor: 'Xususiyatlar muharriri',
  FieldName: 'Maydon nomi',
  ContentType: 'Kontent turi',
  Automatic: 'Avtomatik',
  ManualInput: "Qo'lda kiritish",
  Contents: 'Kontent',
  EnterText: 'Matn kiriting',
  AddControl: "Kontrolni qo'shish",
  AddTag: "Tegni qo'shish",
  TextStyle: 'Matn stili',
  AlignmentOnPage: 'Sahifada tekislash',
  FieldVisibility: "Maydonning ko'rinishi",
  ElementsOfList: "Ro'yxat elementlari",
  AddElement: "Elementni qo'shish",
  SelectFormElementToEdit: 'Tahrirlash uchun shakl elementini tanlang',
  SavingTemplate: 'Shablonni saqlash',
  TemplateName: 'Shablon nomi',
  EnterTemplateName: 'Shablon nomini kiriting',
  MyApplications: 'Mening arizalarim',
  Executed: 'Bajarilgan',
  Tags: 'Teglar',
  ScanQRCodeForSignature: 'Imzo chekish uchun QR kodni skanerlang',
  DocumentHasBeenSigned: 'Hujjatga imzo chekildi',
  NotRequiredField: 'Majburiy kiritish maydoni emas',
  Rejected_male: 'Rad etilgan',
  AddTemplateCategory: "Shablon toifasini qo'shish",
  EditTemplateCategory: 'Shablon toifasini tahrirlash',
  AppointmentTypes: 'Qabuliga yozish turlari',
  TemplateCategories: 'Hujjat shablon toifalari',
  TemplateCategorySuccessfullyAdded: 'Shablon toifasi muvaffaqiyatli qo‘shildi',
  TemplateCategorySuccessfullyUpdated: 'Shablon toifasi muvaffaqiyatli yangilandi',
  TemplateCategorySuccessfullyDeleted: 'Shablon toifasi muvaffaqiyatli oʻchirildi',
  PrintDocuments: 'Hujjatlarni chop etish',
  EnterValue: "Ma'lumot kiriting",
  ResponsiblePerson: "Mas'ul shaxs",
  Valuess: 'Qiymatlar',
  AreYouSureToDeleteTag: "Siz haqiqatan ham shu tagni o'chirmoqchimisiz",
  Assignments: 'imzolar',
  Value: 'Qiymat',
  PendingExecution: 'Kutilmoqda',
  DocumentTemplateExecutors: 'Hujjat shablon ijrochilari',
  AddTemplateExecutor: 'Hujjat shabloni bajaruvchisini yaratish',
  EditTemplateExecutor: 'Hujjat shabloni bajaruvchisini tahrirlash',
  DocumentTemplateExecutorSuccessfullyDeleted:
    'Hujjat shabloni bajaruvchisi muvaffaqiyatli o‘chirildi',
  NoDocumentTemplateExecuters: 'Hujjat shablonlari bajaruvchilari yo‘q',
  TemplateCategory: 'Shablon turi',
  Emojis: 'Emojilar',
  AreYouSureToDeleteEmoji: "Siz haqiqatan ham shu emojini o'chirmoqchimisiz",
  NoComments: "Izohlar yo'q",
  OneComment: 'Izoh',
  CommentsFew: 'Izoh',
  CommentsMany: 'Izoh',
  ReactedByYou: 'Yoqdi',
  Like: 'Reaksiya qoldiring',
  InProgressDocuments: 'Bajarilmoqda',
  TopReport: 'TOP rahbariyat tashriflari bo‘yicha hisobot',
  AreYouSureToDeleteComment: "Izohni o'chirmoqchimisiz?",
  DocumentSuccessfullyRejected: 'Hujjat muvaffaqiyatli rad etildi',

  StartDiscussion: 'Munozarani boshlang',
  Expand: "To'liq ko'rsatish",
  Hide: 'Bekitish',
  ClientOrganization: 'Mijoz',
  Fulfilled: 'Bajarilganlar',
  DocumentSuccessfullyFulfilled: 'Hujjat muvaffaqiyatli bajarildi',
  Team: 'Jamoa',
  PurposeOfProject: 'Loyiha maqsadi',
  AcceptDate: "Shu kun ma'lumotlarni so'rash",
  ChooseExactDate: "So'rov uchun aniq sanani tanlang",
  getAttendanceByDatetime: "Davomatni sana bo'yicha olish",
  AttendanceDataRequestedWait5Minutes: "Davomat ma'lumotlari so'raldi. 5 daqiqa kuting.",
  EmployeesSome: 'Xodim',
  EmployeesMuch: 'Xodim',
  EmployeeSearch: 'Xodimni qidirish',
  NoEmployees: "Xodimlar yo'q",
  MyDrive: 'Mening diskim',
  ProjectTitleRu: 'Loyihaning nomi (rus tilida)',
  ProfileSessions: 'Faol sessiyalar',
  DeviceType: 'Qurilma turi',
  IpAddress: 'IP-manzil',
  TimeOfLogin: 'Kirish vaqti',
  Sessions: 'Sessiyalar',
  ProjectTitleUz: "Loyihaning nomi (o'zbek tilida)",
  Reaction: 'Reaksiya',
  NoReaction: 'Reaksiya yo‘q',
  Reactions: 'Reaksiyalar',
  More: "Ko'proq",
  FolderCreate: 'Papka yaratish',
  FileAdd: 'Fayl qo‘shish',
  RecycleBin: 'Chiqindilar qutisi',
  FolderIsEmpty: 'Bu papka bo‘sh',
  ReasonsForInitializingOfBussiness:
    "Loyihani boshlash sabablari, loyihani boshlashga sabab bo'lgan sabablar va holatlar ko'rsatilgan.",
  FolderName: 'Papka nomi',
  EditFolder: 'Papkani tahrirlash',
  CreateNewFolder: 'Yangi papka yaratish',
  Selected: 'Tanlaganlar',
  Share: 'Ulashish',
  новый: 'yangi',
  ShowMore: "Ko'proq yuklash",
  BusinessOrOtherReasonsForInitiatingTheProject:
    'Biznes yoki loyihani boshlash uchun boshqa sabablar',
  ProjectBudget: 'Loyiha byudjeti',
  CriteriaForAchievingProjectGoals:
    "Loyiha maqsadlariga erishish mezonlari (loyiha maqsadlariga erishish uchun o'lchanadigan mezonlar)",
  ProjectFullfilmentCriteria:
    "Loyiha maqsadlariga erishish mezonlari o'lchanadigan mezonlarni ko'rsatadi, ularning bajarilishi loyiha maqsadlariga erishishga yordam beradi.",
  ProjectBoundaries: 'Loyiha chegaralari (loyihaga kiritilgan ish tavsifi)',
  ProjectBoundariesDetails:
    'Loyiha chegaralari, loyihaga kiritilgan ishlarning batafsil tavsifi, shu jumladan loyiha doirasida amalga oshirilmagan ishlar (topshiriqlar).',
  ProjectLimitations: 'Loyiha cheklovlari',
  LimitationProjectsDescription:
    'Loyihani amalga oshirishni cheklovchi omillarning tavsifi (huquqiy, moliyaviy, resurs, kalendar, shuningdek, boshqa loyihalar tomonidan yuklanganlar va boshqalar',
  ProjectAssumptions: 'Loyiha taxminlari',
  AlternativeOptionsForProjectImplementationMechanisms:
    'Loyihani amalga oshirish mexanizmlarining muqobil variantlari',
  ExpectedRisksOfTheProject: 'Loyihaning kutilayotgan xavflari',
  Interdepartmental: 'Idoralararo',
  SpecificationUsedBySeveralOrgs:
    "Agar tizim bir nechta tashkilotlar tomonidan foydalanilsa, ko'rsatilgan",
  UsageOfPersonalData: "Shaxsiy ma'lumotlardan foydalanish",
  SystemStorageIdentication: "Tizim shaxsiy ma'lumotlardan foydalansa/saqlasa ko'rsatiladi",
  ReadySolutionSystem: 'Mavjud tizim (tayyor yechim)',
  SolutionProvider: 'Yechim provayderi',
  ProviderInfoNumber:
    "Yechim provayderining aloqa ma'lumotlari, to'liq yuridik nomi, TIN (soliq to'lovchining identifikatsiya raqami), yuridik va haqiqiy manzillar: mamlakat, viloyat, pochta indeksi, tuman, shahar, ko'cha, uy, xalqaro formatdagi aloqa telefonlari va faks raqamlari: (+ 998 XX XXX-XX-XX), elektron pochta manzili ko'rsatilgan.",
  ConfidentinalInfo: "Maxfiy ma'lumotlar",
  ContainsClosedDataType:
    "Tizimda yopiq turdagi ma'lumotlar (DSP va boshqalar) mavjud bo'lsa, ko'rsatiladi.",
  UniqueIdentifier: 'Noyob identifikator',
  IssuedConclusion: 'Xulosa chiqargan organ',
  PurposeOfTheConclusion: 'Xulosa maqsadi',
  ConclusionNumber: 'Xulosa raqami',
  DateOfConclusion: 'Xulosa sanasi',
  ConclusionFiles: 'Xulosa fayllari',
  ShortProjectTitle: 'Qisqa loyiha nomi',
  ShortProjectTitleReason:
    "Qisqa loyiha nomini ko'rsatish kerak qisqa (qisqartirilgan/ishchi) ichki identifikatsiya qilish uchun foydalaniladigan loyihaning nomi loyihaning",
  TinAdressName: 'Iism, TIN, manzil, telefon, faks, elektron pochta',
  ProjectType: 'Loyiha turi',
  InvalidPanoramaImage: 'Rasmingiz panorama bo‘la olmaydi. Iltimos, boshqa rasm yuklang.',
  AdditionalInfo: 'Qo‘shimcha Ma’lumot',
  MainProject: 'Asosiy loyiha',
  SourceOfFunding: 'Moliyalashtirish manbai',
  WebAddress: 'Loyiha web manzili',
  LessOneBillion: '1 milliarddan kam',
  MoreOneBillion: '1 milliarddan ko‘p',
  ProjectTypes: 'Loyihalar turlari',
  ProjectTags: 'Loyiha teglari',
  FinancingTypeProjects: 'Loyihalarni moliyalashtirish turlari',
  InitiativeCategories: 'Tashabbus toifalari',
  ProjectIndustries: 'Loyiha tarmoqlari',
  Block: 'Blok',
  ProjectinitiatorLabel: 'Loyihani boshlash uchun sabab',
  CannotDeleteThisTag: 'O‘chirish imkonsiz: ushbu teg boshqa loyihalarda ishlatilgan',
  TagWasCreatedEarlier: 'Teg ilgari yaratilgan',
  DocumentCreationDate: 'Hujjatni yaratgan vaqti',
  Summ: "So'm",
  NoDataForSelectedDepartment: 'Tanlangan bo‘lim uchun ma’lumot yo‘q',
  Uploading: 'Yuklanmoqda...',
  FileTooLarge: 'Fayl hajmi 10MB dan oshmasligi kerak.',
  PanoramaRequired:
    'Panoramali formatda rasm yuklang (eni balandligidan kamida 2 barobar katta bo‘lishi kerak).',
  PanoramaNotAllowed: 'Oddiy yozuvlar uchun panoramali rasmlar taqiqlangan.',
  FileUploadSuccess: 'Fayl muvaffaqiyatli yuklandi!',
  FileUploadError: 'Faylni yuklashda xatolik yuz berdi.',
  AreYouSureMoveFileToTrash: 'Siz ushbu faylni korzinkaga yubormoqchimisiz',
  AreYouSureYouWantToDeleteAll: 'Siz bularning barchasini o‘chirmoqchimisiz',
  AreYouSureMoveFolderToTrash: 'Siz ushbu papkani korzinkaga yubormoqchimisiz',
  Restore: 'Qaytarish',
  CleanFilter: 'Filtrni tozalash',
  BlockName: 'Blok nomi',
  Permission: 'Ruxsat',
  InnMustBeNumeric: "INN faqat raqamlardan iborat bo'lishi kerak",
  InnMustBe9Digits: "INN 9 ta raqamdan iborat bo'lishi kerak",
  ReadWrite: "O'qish/Yozish",
  Read: "O'qish",
  Disable: "O'chirilgan",
  SuccessfullyUpdated: 'Muvaffaqiyatli yangilandi',
  Access: 'Kirish huquqi',
  AddPermission: 'Ruxsat qo‘shish',
  AddRolePermission: 'Rol yaratish va ruxsat biriktirish',
  Deputies: 'O‘rinbosarlar',
  Subs: 'Xodimlar',
  LeadersMultiple: 'Bir nechta rahbar qo‘shish mumkin',
  DeputiesMultiple: 'Bir nechta o‘rinbosar qo‘shish mumkin',
  SubsMultiple: 'Bir nechta xodim qo‘shish mumkin',
  'Saving...': 'Saqlanmoqda...',
  CreateError: 'Bo‘limni yaratishda xatolik yuz berdi',
  OperationError: 'Amaliyotda xatolik',
  NameRu: 'Nomi (Ru)',
  NameUz: 'Nomi (Uz)',
  EnterDepartmentName: 'Bo‘lim nomini kiriting',
  NoChildDivisions: 'Tegishli bo‘limlar yo‘q',
  AddChildDivision: 'Tegishli bo‘lim qo‘shish',
  StructureEmpty: "Struktura bo'sh",
  Structure: 'Struktura',
  Companies: 'Tashkilotlar',
  Current: 'Joriy',
  AuthMethod: 'Avtorizatsiya usuli',
  SessionDeleteConfirmation: 'Siz rostdan ham ushbu sessiyani o‘chirmoqchimisiz',
  SessionDeletedSuccessfully: 'Sessiya muvaffaqiyatli o‘chirildi',
  SuccessfullyCreated: 'Muvaffaqiyatli yaratildi',
  AreYouSureToDelete: "O'chirishga ishonchingiz komilmi?",
  FindByNameOrPosition: "Ismi bo'yicha toping",
  ConfirmDocumentCompletion: 'Siz haqiqatdan ham ushbu hujjatni bajarishni istaysizmi',
  DocumentSuccessfullySigned: 'Hujjatga muvaffaqiyatli imzo qo‘yildi',
  MarkAllAsRead: 'Barchasini o‘qish',
  AllEmployees: 'Jami xodimlar',
  WhoYouSend: 'Kimga yubormoqchisiz',
  '#Shared#': 'Ulashilgan',
  You: 'Siz',
  AllStopShare: 'Hammadan ulashishni to‘xtatish',
  MeetingNameMustAlotCharacters: "Uchrashuv nomi 2 dan 256 ta belgigacha bo'lishi kerak",
  TitleStartWithLetter: 'Sarlavha harf bilan boshlanishi kerak',
  Struktura:
    'Единый интегратор по созданию и поддержке государственных информационных систем-ООО"UZINFOCOM": \'Struktura: Davlat axborot tizimlarini yaratish va qoʻllab-quvvatlash boʻyicha yagona integrator – “UZINFOCOM” MChJ\'',
  SpecialCharactersNotAllowed: 'Maxsus belgilar kiritish mumkin emas',
  OrganizationSuccessfullyDeleted: 'Toshkilot muvaffaqiyatli oʻchirildi',
  CategorySuccessfullyDeleted: 'Kategoriya muvaffaqiyatli oʻchirildi',
  StatusSuccessfullyDeleted: "Status o'chirildi",
  AreYouSureToDeleteAbsenceAskStatuses:
    'Siz haqiqatan ham ushbu Ishdan javob olish statusini ochirmoqchimisiz',
  AreYouSureToDeleteAbsenceAskCategories:
    "Siz haqiqatan ham ushbu ishdan javob olish kategoriyasini o'chirmoqchimisiz",
  FilterByRole: 'Rol bo‘yicha filter',
  CreateCopy: 'Nusxa yaratish',
  AreYouSureToDeleteOrganization: "Siz haqiqatan ham ushbu tashkilotni o'chirmoqchimisiz",
  UploadFileCanceled: 'Fayl yuklash bekor qilindi',
  Signed: 'Imzolangan',
  Reviewed: 'Ko‘rib chiqilgan',
  Archived: 'Arxivlangan',
  Cancelled: 'Bekor qilingan',
  CancelShared: 'Ulashilganlarni bekor qilish',
  RecipientDiskNotCreated: 'Qabul qiluvchining diski hali yaratilmagan',
  ActualSize: 'Haqiqiy o‘lcham',
  PageFit: 'Sahifa o‘lchamiga moslashtirish',
  PageWidth: 'Sahifa kengligiga moslashtirish',
  ItemBeforeShared: 'Qayta ulashish mumkin emas',
  UserDiskNotCreate: 'Qabul qiluvchining diski hozircha yaratilmagan',
  Delegated: 'Topshirilgan',
  Skipped: 'O‘tkazib yuborilgan',
  AllEmployeess: 'Barcha xodimlar',
  CopyCreatedSuccessfully: 'Nusxa muvaffaqiyatli yaratildi',
  AskAnything: 'Biror narsa so‘rang',
  ChatAI: 'Sun’iy intellekt chat',
  NewChat: 'Yangi chat',
  Chats: 'Chatlar',
  HowCanIHelp: 'Sizga qanday yordam bera olaman?',
  SelectCategory: 'Kategoriyani tanlang',
  ErrorAddingLeaveRequest: "So'rovini qo'shishda xatolik yuz berdi",
  UpdateSystem: 'Biz tizimni yangiladik',
  UpdateSystemDesc:
    'Ba’zi yaxshilanishlarni kiritdik. O‘zgarishlar kuchga kirishi uchun iltimos, “Qayta yuklash” tugmasini bosing',
  Reload: 'Qayta yuklash',
  ImageIsRequired: 'Rasm talab qilinadi',
  To: 'Gacha',
  Preview: 'Ko‘rib chiqish',
  WorkTimeReports: 'Ish vaqtiga oid hisobotlar',
  Chats: 'Chatlar',
  CreateNewGroup: "Yangi guruh qo'shish",
  Cancel: 'Bekor qilish',
  Save: 'Saqlamoq',
  IncludeInAttendanceReport: 'Davomat hisobotiga qo‘shilsin',
  Contacts: 'Kontaktlar',
  Blanks: 'Blankalar',
  Attachments: "Qo'shimchalar",
  DocsName: 'Hujjat nomi',
  CreatedDate: 'Yaratilgan sana',
  Employers: 'Ischilar',
  MySkud: 'My Skudim',
  Departments: "Bo'limlar",
  Users: 'Foydalanuvchilar',
  FullName: 'Ism sharif',
  HrmUsers: 'HRM foydalanuvchilari',
  Actions: 'Harakatlar',
  ConnectToHRM: "HRM bilan bog'lash",
  AddStatus: "Status qo'shish",
  AddUser: "Foydalanuvchini qo'shish",
  Roles: 'Rollar',
  Add: "Qo'shish",
  Submit: 'Yuborish',
  Download: 'Yuklash',
  Search: 'Qidirish',
  Profile: 'Profil',
  Message: 'Xabar',
  Employees: 'Xodimlar',
  Notifications: 'Ogohlantirishlar',
  FullscreenToggle: 'Toʻliq ekranni yoqish/oʻchirish',
  Welcome: 'Xush kelibsiz',
  WelcomeToOurCommunity: 'Jamiyatimizga xush kelibsiz',
  WeСreateUniqueItSolutions:
    "Biz jamiyat va hamkorlarimizga o'z maqsadlariga erishishga yordam beradigan, qulaylikni ta'minlovchi va hayotni yangi imkoniyatlar bilan to'ldirishga yordam beradigan noyob IT-yechimlarni yaratamiz",
  SignIn: 'Kirish',
  Username: 'Foydalanuvchi nomi',
  Password: 'Parol',
  EnterLogin: 'Login kiriting',
  Hint: "Ko'rsatma",
  Press: 'Bosing',
  here: 'shu yerni',
  toShowEducationTour: "ko'rsatma turini ko'rish uchun",
  Further: 'Keyingi',
  Previous: 'Oldingi',
  EnterPassword: 'Parolni kiriting',
  EnterUzinfocomMailLogin:
    'Uzinfocom pochtasiga kirish uchun administratorlardan olingan loginni kiriting',
  EnterUzinfocomMailPassword:
    'Uzinfocom pochtasiga kirish uchun administratordan olingan parolni kiriting',
  PressButton: 'Tugmani bosing',
  PressThisButtonOrEnterButtonOnKeyboard:
    'Ushbu tugmani yoki kompyuteringiz klaviaturasidagi Enter tugmasini bosing',
  Today: 'Bugun',
  InFewDays: 'Yaqin kunlarda',
  Greeting: 'Salom',
  GladToSeeYouInOurTeam: "Sizni jamoamizda ko'rganimizdan xursandmiz",
  YourEnergyAndTalentWillBecomeContribution:
    "Sizning kuchingiz va istedodingiz umumiy ishimizga bebaho hissa bo'ladi",
  ForwardToNewAchievements: 'Yangi yutuqlar sari intiling',
  Start_verb: 'Boshlash',
  YouMustEnterUsername: 'Foydalanuvchi nomini kiriting',
  PasswordIsTooShort: "Parol juda qisqa - kamida 4 ta belgidan iborat bo'lishi kerak",
  DocumentName: 'Hujjat nomi',
  CreationDate: 'Yaratilgan sanasi',
  IncorrectLoginOrPassword: "Siz kiritgan foydalanuvchi nomi yoki parol noto'g'ri",
  InternalDocuments: 'Ichki hujjatlar',
  DownloadMobileApplication: 'Mobil ilovani yuklab olish',
  HappyBirthdayСongratulations:
    'Tug`ilgan kuningiz bilan! Ahil jamoamiz nomidan sizni yorqin kuningiz bilan chin dildan samimiy tabriklaymiz! Sizga ulkan muvaffaqiyatlar, doimiy omad, sihat-salomatlik va hayotingizda cheksiz baxt tilaymiz. Sevimli ishingiz sizga doimo quvonch va zavq olib kelsin. Sizning kasbiy bilimingiz, katta tajribangiz, yangi foydali g‘oyalaringiz hamkorlikdagi faoliyatimizda yuqori natijalarga erishish imkonini bersin.',
  BestRegardsUzinfocomTeam: 'Hurmat bilan, Uzinfocom jamoasi.',
  SelectPhase: 'Fazani tanlang',
  GroupName: 'Guruh nomi',
  AbsentList: "Ishga kelmaganlar ro'yxati",
  fromNumber: '{{val, string}} dan',
  untilNumber: '{{val, string}} gacha',
  Claims: "So'rovlar",
  DailyAttendance: 'Kuniga tashriflar hisobi',
  Vacations: "Ta'tillar",
  SickLeaves: "Kasallik ta'tillari",
  BusinessTrips: 'Ish safarlari',
  MyDaysOff: 'Ish safarlari va dam olishlar',
  LeaveRequest: 'Ishdan javob olish',
  AbsenceAsks: 'Ish safarlari va dam olishlar',
  WorkDaysOff: 'Ishdan javob olish',
  WorkTakeOffRequest: "Ishdan javob olish so'rovi",
  Calendar: 'Kalendar',
  GettingPermissionForEnter: 'Kirish uchun ruxsat olish',
  LoginType: 'Kirish turi',
  Workload: 'Ish yuki',
  BackToLoginPage: 'Kirish sahifasiga qaytish',
  No: "Yo'q",
  VisitBooking: 'Uchrashuv qabuliga yozilish',
  None: "Yo'q",
  Top: 'Top',
  Volonter: 'Fidoyi',
  Trainee: 'Stajyor',
  Probation: 'Sinov muddati',
  Appointment: 'Qabulga yozilish',
  BestRegardsUzAtomTeam: 'C уважением, команда UzAtom.',
  UzAtom_fullname:
    "O'zbekiston Respublikasi Vazirlar Mahkamasi huzuridagi Atom energiyasi agentligi",
  ScanFromMobileToEnter: 'Kirish uchun mobil ilovadan skan qiling',
  SignInWithMyId: 'MyID orqali kirish',
  EnterUzAtomMailLogin:
    'UzAtom pochtasiga kirish uchun administratorlardan olingan loginni kiriting',
  EnterUzAtomMailPassword:
    'UzAtom pochtasiga kirish uchun administratordan olingan parolni kiriting',
  userinfodontmatch: 'Foydalanuvchi topilmadi. Iltimos, foydalanuvchi nomi va parolni tekshiring',
  Singout: 'Siz tizimdan chiqdingiz!',
  MyIDAuthError: 'MyID orqali avtorizatsiya xatosi. Qayta harakat qiling',
  New: 'Yangi',
  InReview: 'Tasdiqlashda',
  Approved: 'Tasdiqlandi',
  StatusRejected: 'Rad etildi',
  Pending: 'Kutish',
  TemplatesConstructor: 'Shablonlar konstruktori',
  TemplatesManagement: 'Shablonlarni boshqarish',
  TemplateConstructor: 'Shablon konstruktori',
  ToWhomIsAddressed: 'Adresat',
  WhoToSendForApprove: 'Tasdiqlash uchun kimni yuborish kerak',
  AreYouSureToDeleteTemplate: "Siz haqiqatan ham shablonni o'chirishni xohlaysizmi?",
  TemplateSuccessfullyDeleted: "Shablon muvaffaqiyatli o'chirildi",
  TemplateRejected: 'Shablon rad etildi',
  TemplateSuccessfullyApproved: 'Shablon muvaffaqiyatli tasdiqlandi',
  AreYouSureToRejectTemplate: 'Siz haqiqatan ham shablonni rad etishni xohlaysizmi?',
  NoApplications: "Arizalar yo'q",
  Accessibility: 'Mavjudlik',
  Language: 'Til',
  Verified: 'Tasdiqlangan',
  Rejected: 'Rad etilgan',
  InputText: 'Matn kiriting',
  InputMultilineText: "Ko'p qatorli matn kiriting",
  SelectDate: 'Sanani tanlang',
  InputNumber: 'Sonni kiriting',
  FillList: "Ro'yxatni to'ldiring",
  SignDocument: 'Hujjatni imzolang',
  ScanQRCodeWithUportalApplication: 'Uportal ilovasi bilan QR-kodni skanerlang',
  NeedToSignDocument: 'Hujjatni imzolash kerak',
  ToSign: 'Imzolash',
  ToList: 'Roʻyxatga',
  Note: 'Izoh',
  TableEditor: 'Jadval muharriri',
  Rows: 'Qatorlar',
  Row: 'Qator',
  Columns: 'Ustunlar',
  Application: 'Ariza',
  ApplicationBody: 'Ariza matni',
  ApprovalRoute: 'Tasdiqlash marshruti',
  TemplateFields: 'Shablon maydonlari',
  SignersArrayIsEmpty: "Tasdiqlovchi shaxslar ro'yxati bo'sh",
  DragAndDropElementsToChangeRoute:
    "Marshrutni o'zgartirish uchun elementlarni sudrab olib tashlang",
  CreatorAndHisChiefsSignatures: 'Yaratuvchi va uning boshliqlarining imzolari',
  TemplateIsEmpty: "Shablon bo'sh ekan",
  ClickButtonToStart: 'Boshlash uchun quyidagi tugmani bosing',
  SelectEmployee: 'Hodimni tanlash',
  ApproversSignatures: 'Tasdiqlovchilar imzolari',
  ApplicantSignature: 'Ariza beruvchining imzosi',
  Select: 'Tanlash',
  ChooseEmployee: 'Xodimni tanlash',
  DeleteElement: "Elementni o'chirish",
  AreYouSureToDeleteElement: "Siz haqiqatan ham shu elementni o'chirmoqchimisiz?",
  ConsecutiveRoute: 'Ketma-ket marshrut',
  ParallelRoute: 'Parallel marshrut',
  Addressee: 'Adresat',
  Subtitle: 'Sarlavha',
  Document: 'Hujjat',
  Documents: 'Hujjatlar',
  LoadingTemplate: 'Shablon yuklanmoqda',
  MultilineText: "Ko'p qatorli matn",
  ProjectsReport: 'Loyiha hisoboti',
  SearchByEmployee: "Xodim bo'yicha qidirish",
  ActualAmount: 'Haqiqiy miqdor',
  PaymentId: "To'lov ID",
  ActualAmmount: 'Haqiqiy summa',
  Paragraph: 'Paragraf',
  MyDocuments: 'Mening hujjatlarim',
  Hours: 'soat',
  WorkCalendar: 'Ish kunlari kalendari',
  EditWorkHour: 'Ish soatini tahrirlash',
  DepartmentsReport: 'Bir oylik hisobot',
  NonAttendances: "Yo'qligi",
  Days: 'Kun',
  Reasonable: 'Sababli',
  TotalWorkingTime: 'Ishdagi umumiy vaqt',
  Hours: 'Soat',
  AverageTimeInBuilding: "Binoda sarflangan o'rtacha vaqt",
  WorkingDays: 'Ish kunlari',
  Exits: 'Chiqishlar',
  QuantityShort: 'Soni',
  Minutes: 'Daqiqalar',
  PresentWorkingDays: 'Ishlangan ish kunlari (kun)',
  WorkedHoursOnWorkdays: 'Ish kunlarida ishlangan soatlar (soat)',
  WeekendHolidayDaysPresent: 'Dam olish va bayram kunlaridagi chiqishlar (kun)',
  WorkedHoursOnWeekends: 'Dam olish va bayram kunlarida ishlangan soatlar (soat)',
  AverageWorkedHoursOnWeekends: 'Dam olish kunlaridagi o‘rtacha ish vaqti (soat)',
  LateArrivalCount: 'Kechikishlar soni',
  TotalLateHours: 'Kechikishlar (soat)',
  ExcusedAbsenceDays: 'Sababli kelmaslik (kun)',
  UnexcusedAbsenceDays: 'Sababsiz kelmaslik (kun)',
  TotalDurationHours: 'Ishda bo‘lgan umumiy vaqt (soat)',
  BusinessTripDays: 'Ish safari(kun)',
  WorkTrip: 'Xizmat safari',
  VacationDays: 'Ta’til kunlari',
  SickLeaveDays: 'Kasal kunlari',
  NoAvailableDepartments: "Bo'ysunadigan bo'limlar yo'q ekan",
  TOP: 'TOP',
  TotalWorkingDays: 'Ish kunlarining umumiy soni',
  TotalWorkingHours: 'Ish soatlarining umumiy soni',
  AverageWorkedHoursOnWorkdays: "Ish kunlaridagi o'rtacha ish vaqti (soat)",
  TOPS: 'TOPlar',
  DocumentChecking: 'Hujjat tekshirishi',
  CheckSignatures: 'Imzolarni tekshirish',
  EnterDocumentId: 'Hujjat identifikatorini kiriting',
  WithoutStatus: 'Statussiz',
  ProjectsDashboard: 'Loyiha boʻyicha dashbord',
  Last10Projects: 'Oxirgi 10 loyihalar',
  Subdivision: "Bo'linma",
  ShowTopManager: "TOP-menejerni ko'rsatish",
  CreateProject: 'Loyiha yaratish',
  Fulfilled: 'Bajarilgan',
  BlocksDailyReport: "Bloklar bo'yicha kunlik hisoboti",
  NoData: "Ma'lumot yo'q",
  ExpandAll: 'Hammasini kengaytirish',
  Post: 'Lavozim',
  SummaryReportForOneDay: "Kun bo'yicha qisqacha hisobot",
  TotalEmployees: 'Xodimlar soni',
  ComingToWork: 'Ishga kelishlar',
  Latecomers: 'Kech kelganlar',
  LateCome: 'Kech keldi',
  EarlyLeft: 'Erta ketishlar',
  Absent: 'Ishga kelmaganlar',
  WithoutReason: 'Sababsiz',
  OnVacation: "Ta'tilda",
  OnBusinessTrip: 'Ish safarida',
  OnSickLeave: "Kasallik ta'tilida",
  OnNumber: '{{count}} ga',
  Violation: 'Buzilish',
  Lateness: 'Kechikish',
  EarlyLeaving: 'Erta ketish',
  AbsenceOnWork: "Ishda yo'qligi",
  LateTimeOn:
    '{{hours}} {{hours_label}} {{minutes}} {{minutes_label}} {{seconds}} {{seconds_label}}ga kechikish',
  EarlyLeavingOn:
    '{{hours}} {{hours_label}} {{minutes}} {{minutes_label}} {{seconds}} {{seconds_label}}ga erta ketish',
  hours_label: 'soat',
  minutes_label: 'daqiqa',
  seconds_label: 'soniya',
  SkudStatistics: 'SKUD. Statistika',
  FromDate: 'Qaysi sanadan',
  ToDate: 'Qaysi sanagacha',
  CameToOffice: 'Ofisga kelganlar',
  SickBusinessTimeOff: "Kasal/ish safari/javob so'raganlar",
  Lates: 'Kechikishlar',
  LatesAndEarlyLeavings: 'Kechikishlar va erta ketishlar',
  EarlyLeavings: 'Erta ketishlar',
  WithoutReasons: 'Sababsiz',
  StatisticsByBlocks: "Bloklar bo'yicha statistika",
  ClaimDataUnavailable: "So'rov ma'lumotlari mavjud emas",
  LocalNormativeActs: 'Mahalliy normativ hujjatlar',
  Finish: 'Tugatish',
  Edit: "O'zgartirish",
  Upload: 'Yuklash',
  MandatoryConfirmation: 'Majburiy tasdiqlash',
  Monitoring: 'Monitoring',
  SelectDocument: 'Hujjatni tanlang',
  AssignedEmployees: 'Tayinlangan xodimlar',
  Confirmed: 'Tasdiqlaganlar',
  NotConfirmed: 'Tasdiqlamaganlar',
  CompletionPercent: 'Bajarilish foizi',
  Department: 'Departament',
  Division: "Bo'lim",
  division: "bo'lim",
  Group: 'Guruh',
  Position: 'Lavozim',
  EmployeeSearch: "F.I.Sh. bo'yicha qidirish",
  ToSign: 'Imzolash',
  PendingSignature: 'Imzoda',
  Signed: 'Imzolangan',
  WhoHas: 'Kimda',
  Sign: 'Imzolash',
  Rejected_plural: 'Rad etilgan',
  NoDocuments: "Hujjatlar yo'q ekan",
  ArchiveDocuments: 'Arxiv hujjatlar',
  UploadDocument: 'Hujjatni yuklash',
  DocumentSignatureType: 'Hujjat imzolash turi',
  DaysUntilDeadline: 'Dedlayngacha kunlar soni',
  SendToAll: 'Hammaga yuborish',
  FileIsRequired: 'Fayl kiritilishi shart',
  SelectFile: 'Faylni tanlash',
  ForFamiliarization: 'Tanishishga',
  ForSigning: 'Imzolashga',
  AreYouSureToDeleteDocument: "Siz haqiqatan ham hujjatni o'chirmoqchimisiz?",
  DocumentSuccessfullyDeleted: "Hujjat muvaffaqiyatli o'chirildi",
  SelectedDocuments: 'Tanlangan hujjatlar',
  DocumentTitle: 'Hujjat nomi',
  DocumentDescription: 'Hujjat tavsifi',
  ToWhomToAssignSelectedDocuments: 'Tanlangan hujjatlarni kimga tayinlash kerak',
  CheckAndSend: "Ma'lumotlarni tekshiring va 'Yuborish' tugmasini bosing",
  SearchByDepartmentsAndEmployees: "Bo'linmamlar va xodimlar bo'yicha qidirish",
  DocumentSuccessfullySent: 'Hujjat muvaffaqiyatli yuborildi',
  DisconnectFromHRM: 'HRMdan aloqani uzish',
  NoActionsAvailable: 'Amal mavjud emas',
  DocumentVersions: 'Hujjat versiyalari',
  ShowDocumentVersions: "Hujjat versiyalarini ko'rish",
  DocumentInformation: "Hujjat ma'lumotlari",
  YouNeedToSignDocumentToContinueUsingSystem:
    'Sizda tanishishga/imzolashga hujjat bor. Tizimdan foydalanishni davom ettirish uchun ushbu hujjatni tanishish/imzolash kerak',
  NumberOfAssignedEmployees: 'Hujjat tayinlangan xodimlar soni',
  DocumentSuccessfullySigned: 'Hujjat muvaffaqiyatli imzolandi',
  ToFamiliarize: 'Tanishish',
  Version: 'Versiya',
  LNAManagement: 'MNH boshqarish',
  FileSuccessfullyUploaded: 'Fayl muvaffaqiyatli yuklandi',
  ChoosePdfFile: 'PDF hujjatni tanlang',
  UploadNewDocumentVersion: 'Hujjatning yangi versiyasi yuklash',
  DocumentSuccessfullyUpdated: 'Hujjat muvaffaqiyatli yangilandi',
  DocumentStatus: 'Hujjat holati',
  Rejected_male: 'Rad etilgan',
  ShowChangesHistory: "O'zgarishlar tarixini ko'rsatish",
  ChangesHistory: "O'zgarishlar tarixi",
  Template: 'Shablon',
  ViewNews: "Yangiliklarni ko'rish",
  InPending: 'Kutishda',
  Familiarized_plural: 'Tanishilgan',
  Approved_plural: 'Tasdiqlangan',
  Signed_plural: 'Imzolangan',
  AboutDocument: 'Hujjat haqida',
  StructureIsNotFetched: 'Kompaniya tuzilmasini yuklab bo‘lmadi.',
  UpdatingList: 'Ro‘yxat yangilanmoqda…',
  AlreadyChosen: ' • boshqa guruhda allaqachon tanlagan',
  Current_female: 'Joriy',
  ToOpen: 'Ochish',
  AllDocumentsSuccessfullySent: 'Barcha hujjatlar muvaffaqiyatli yuborildi',
  FieldIsRequired: "Ushbu maydonni to'ldirilishi shart",
  InternalWorkflow: 'Ichki hujjat aylanishi',
  ApplicantSignature: 'Ariza beruvchining imzosi',
  ChooseApplicationType: 'Ariza turini tanlang',
  NotFound: 'Topilmadi',
  SelectStartAndEndDatesToGetDataFromSkud:
    "SKUDdan ma'lumot olish uchun boshlanish va tugash sanalarini tanlang",
  ExecuteRequest: "So'rovni bajarish",
  GetAttendanceByDateRange: "SKUDdan ma'lumot so'rash",
  AttendanceDataRequestedWaitForNotification:
    "Ma'lumotlar so'raldi. So'rovingiz bajarilgandan so'ng sizga ogohlantirish yuboriladi",
  Share: 'Ulashish',
  EnterKeyWordField: 'Maydon uchun kalit so‘zni kiriting',
  SelectTag: 'Tag tanlang',
  EnterKeyWordField: 'Maydon uchun kalit so‘zni kiriting',
  SelectTag: 'Tag tanlang',
  NoOptions: "Variantlar yo'q",
  PortalTechSupport: 'Portalning texnik yordami',
  PortalTechnicalSupport: 'Korporativ portalning texnik yordami',
  NoTodayBirthdays: "Bugun tug'ilgan kunlar yo'q",
  NoIncomingBirthdays: "Yaqin kunlarda tug'ilgan kunlar yo'q",
  HappyBirthdayText:
    "Sizni ushbu ajoyib kun bilan chin dildan tabriklaymiz! Sizga sihat-salomatlik, baxt-saodat, barcha harakatlaringizda muvaffaqiyatlar, ilhom va ijobiy his-tuyg'ular tilaymiz. Har bir kun sizga quvonch va orzularingiz ushalishini tilaymiz!",
  HappyBirthday: 'Tug`ilgan kuningiz bilan',
  DayReport: 'Bir kun uchun hisobot',
  MonthReport: 'Oylik hisobot',
  AttendanceReportMonth: "Oylik tashriflar bo‘yicha bo'limlar hisoboti",
  AttendanceReportADay: "Kunlik tashriflar bo‘yicha  bo'limlar hisoboti",
  SummaryByDepartment: 'Tanlangan kun uchun bo‘limlar bo‘yicha umumiy statistika',
  SummaryByDepartmentAMonth:
    'Tanlangan davr uchun kompaniyaning barcha bo‘limlari bo‘yicha umumiy statistika',
  EmployeesReport: 'Kunlik tashriflar bo‘yicha xodimlar hisoboti',
  EmployeeStatistics: 'Xodimlar statistikasi',
  ByBlocks: 'Bloklar bo‘yicha',
  ByEmployees: 'Xodimlar bo‘yicha',
  OnDate: 'da',
  DetailedDepartmentCards: 'Bo‘limlar bo‘yicha batafsil kartochkalar',
  AggregatedDepartmentAttendance:
    'Tanlangan oy bo‘yicha bo‘limlar kesimida umumlashtirilgan davomat ma’lumotlari',
  AreYouSureDeleteCategory: 'Siz rostdan ham ushbu kategoriyani o‘chirmoqchimisiz',
  DocumentCategories: 'Xujjat kategoriyalari',
  MainCategory: 'Asosiy kategoriya',
  NoParent: 'Ota kategoriya yo‘q',
  NoMainCategory: 'Asosiy kategoriya yo‘q',
  AddSubcategory: 'Quyi kategoriya qo‘shish',
  AttachAdditionalFile: 'Qo‘shimcha faylni biriktirish',
  PreviewApplicationDesc: `Formdagi kerakli maydonlarni to‘ldiring va hujjatni oldindan ko‘rish uchun “Oldindan ko‘rish” tugmasini bosing.`,
  PreviewApplication: 'Oldindan ko‘rish',
  SelectDay: 'Kunni tanlang',
  TopManagementReportDesc: 'TOP rahbariyat tashriflarini SKUD orqali monitoring qilish',
  AttendancePercentage: 'Qatnashish foizi',
  OverallAttendanceStatistics: 'Qatnashish bo‘yicha umumiy statistika',
  EventSuccessfullyUpdated: 'Tadbir muvaffaqiyatli yangilandi',
  MyCalendars: 'Mening kalendarlarim',
  EditCalendarEvent: 'Kalendar tadbirni tahrirlash',
  AddCalendarEvent: "Kalendar tadbirni qo'shish",
  Hybrid: 'Gibrid',
  MyTasks: 'Mening vazifalarim',
  ProjectTasks: 'Loyiha vazifalarim',
  TaskName: 'Vazifa nomi',
  Date: 'Sana',
  StartTime: 'Boshlanish vaqti',
  EndTime: 'Tugash vaqti',
  TimeZone: 'Vaqt zonasi',
  Members: 'Ishtirokchilar',
  Guests: 'Mehmonlar',
  Description: 'Tavsifi',
  Reminder: 'Eslatma',
  AddReminder: 'Eslatma qo‘shish',
  NotificationMethod: 'Bildirishnoma usuli',
  PushNotification: 'Push bildirishnoma',
  Add: 'Qo‘shish',
  SelectCalendar: 'Kalendarni tanlang',
  AllDay: 'Barcha kunlar',
  Repeat: 'Qayta ishlatish',
  AddMember: 'Ishtirokchini qo‘shish',
  AddGuest: 'Mehmonni qo‘shish',
  Cabinet: 'Kabinet',
  Link: 'Havola',
  Add: 'Qo‘shish',
  Tasks: 'Vazifalar',
  MyEvents: 'Mening tadbirlarim',
  Event: 'Tadbir',
  FileAttachments: 'Fayllarni biriktirish',
  Upload: 'Загрузить',
  MyCalendarBeta: 'Mening kalendarim (beta)',
  HrmOrderType: 'HRMdagi buyruq turi',
  SelectHrmOrderType: 'HRMdagi buyruq turini tanlang',
  NoTemplateFields: 'Shablon maydonlari yo‘q',
  EndWorkingTime: 'Ish tugash vaqti',
  StartWorkingTime: 'Ish boshlanish vaqti',
  SelectResource: 'Выберите ресурс',
  BirthdayCardWillBeClosed: "Tabriknoma keyingi tizimdagi avtorizatsiyagacha yopiq bo'ladi",
  Acquainted_plural: 'Tanishilgan',
  Signed_plural: 'Imzolagan',
  CreatedOnes: 'Yaratilganlari',
  SignedOnes: 'Imzolanganlari',
  NotSignedOnes: 'Imzolanmaganlari',
  RejectedOnes: 'Rad etilganlari',
  ArchiveOnes: 'Arxivdagilar',
  ForExecutionOnes: 'Ijro uchun',
  CompletedOnes: 'Yakunlanganlar',
  Signed_plural: 'Imzolagan',
  Signed_plural: 'Imzolagan',
  CreateDocumentsWithAutomaticApprovalRoute:
    'Avtomatik tasdiqlash marshruti bilan ichki hujjatlar yarating',
  CreatingDocuments: 'Hujjat yaratish',
  CreateDocument: 'Hujjat yaratish',
  Archive: 'Arxiv',
  CreatingDocument: 'Hujjat yaratish',
  AttendanceReport: 'Davomat hisoboti',
  Completed: 'Yakunlangan',
  NoTemplate: 'Shablon yo‘q',
  Show: "Ko'rsatish",
  NoTemplate: 'Shablonlar yo‘q',
  AvgHours: 'Ish vaqtida o‘rtacha vaqt (soat)',
  SyncReferences: 'Shablon turlarini HRM bilan sinxronizatsiya qilish',
  SyncOrderTypesReferences: "Yo'riqnoma sinxronizatsiya qilish",
  ReferencesSuccessfullySynchronized:
    'Shablon turlari muvaffaqiyatli HRM ga sinxronizatsiya qilingan',
  ReferencesSynchronizationError:
    'Shablon turlarini HRM bilan sinxronizatsiya qilishda xatolik yuz berdi',
  Synchronization: 'Sinxronizatsiya',
  ItIsNecessaryToAttachFile:
    "Ushbu turdagi hujjat uchun tanlangan shablonga ko'ra, faylni biriktirish kerak",
  AttachFile: 'Faylni biriktiring',
  ConfirmationOfDeletion: "O'chirishni tasdiqlang",
  AreYouSureToDeleteSubcategory:
    "Tanlangan kategoriyani o'chirmoqchimisiz? Barcha bog'liq shablonlar ham o'chiriladi",
  VisitType: 'Davomat holati',
  EarlyLeaving_s: 'Erta ketdi',
  LateAndEarlyLeaving: 'Kech keldi va erta ketdi',
  Absent_s: 'Kelmadi',
  ReasonAbsent: 'Sababli kelmaslik',
  MyTasksIsEmpty: 'Vazifalar topilmadi',
  MyTasksIsEmptyDescription: 'Tanlangan davr uchun hech qanday vazifa yo‘q',
  OnlineEvent: 'Onlayn',
  OfflineEvent: 'Oflayn',
  HybridEvent: 'Gibrid',
  DeadlineDate: 'Topshirish sanasi',
  DateAndTime: 'Sana va vaqt',
  EventDetails: 'Tadbir tafsilotlari',
  EventDescription: 'Tadbir tavsifi',
  SelectColor: 'Rangni tanlang',
  SelectIcon: 'Ikonkani tanlash',
  OutOffice: 'Ofisdan tashqarida',
  WhoCompleteTable: 'Ushbu jadval kim tomonidan to‘ldiriladi',
  PersonalReasons: 'Shaxsiy sabablar',
  OnBusinessMeeting: 'Xizmat uchrashuvlarida',
  OnlyPDFAllowed: 'Faqat PDF formatidagi fayllar',
  MaxFileSizeExceeded: 'Fayl hajmi 5 MB yuqori',
  FilesSuccessfullyAdded: "Fayl muvaffaqiyatli qo'shildi",
  CreateCalendar: 'Kalendar yaratish',
  CalendarSettings: 'Kalendar sozlamalari',
  CalendarTitle: 'Kalendar nomi',
  LayerColor: 'Qatlam rangi',
  CalendarIcon: 'Kalendar belgisi',
  CalendarType: 'Kalendar turi',
  CalendarType_personal: 'Shaxsiy',
  CalendarType_team: 'Jamoa',
  CalendarType_corp: 'Korporativ',
  AccessRights: 'Kirish huquqlari',
  Access_onlyMe: 'Faqat men',
  Access_team: 'Mening jamoam',
  Access_department: 'Butun bo‘lim',
  Access_company: 'Butun kompaniya',
  ValueMustBeMoreThanZero: 'Qiymat 0 dan katta bo‘lishi kerak',
  LastUpdated: "Ma'lumotlar so'ngi yangilangan vaqti: {{lastUpdatedAt}}"
};

export default locale;
